import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit, NgZone, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import { MasterService } from '../../@core/services/master.service';
import { RoleService } from '../../@core/services/role.service';
import { NbToastrService } from '@nebular/theme';
import { number } from 'echarts';
import { ExportService } from '../../@core/services/export.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { FetchSuppliersComponent } from '../fetch-suppliers/fetch-suppliers.component';
import { forkJoin } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'ngx-project-view',
  templateUrl: './project-view.component.html',
  styleUrls: ['./project-view.component.scss']
})
export class ProjectViewComponent implements OnInit, AfterViewInit {
  get isTrassconServer(): boolean {
    const apiUrl = ((environment as any)?.apiUrl || '').toLowerCase();
    const hostname = (window.location.hostname || '').toLowerCase();
    const href = (window.location.href || '').toLowerCase();
    const customer = (this.customerInfoData?.customerName || this.customerInfoData?.customer_name || '').toLowerCase();

    return (
      apiUrl.includes('trasccon') ||
      apiUrl.includes('trascon') ||
      apiUrl.includes('trasscon') ||
      hostname.includes('trasccon') ||
      hostname.includes('trascon') ||
      hostname.includes('trasscon') ||
      href.includes('trasccon') ||
      href.includes('trascon') ||
      href.includes('trasscon') ||
      customer.includes('trasccon') ||
      customer.includes('trascon') ||
      customer.includes('trasscon')
    );
  }

  get showMarkupButton(): boolean {
    return !this.isTrassconServer;
  }

  get showPercentColumns(): boolean {
    return !this.isTrassconServer;
  }

  get isAucukumServer(): boolean {
    const apiUrl = ((environment as any)?.apiUrl || '').toLowerCase();
    const hostname = (window.location.hostname || '').toLowerCase();
    const href = (window.location.href || '').toLowerCase();
    const customer = (this.customerInfoData?.customerName || this.customerInfoData?.customer_name || '').toLowerCase();

    return (
      apiUrl.includes('aucukum') ||
      apiUrl.includes('auckam') ||
      apiUrl.includes('auckum') ||
      apiUrl.includes('ngp') ||
      hostname.includes('aucukum') ||
      hostname.includes('auckam') ||
      hostname.includes('auckum') ||
      hostname.includes('ngp') ||
      href.includes('aucukum') ||
      href.includes('auckam') ||
      href.includes('auckum') ||
      href.includes('ngp') ||
      customer.includes('aucukum') ||
      customer.includes('auckam') ||
      customer.includes('auckum') ||
      customer.includes('ngp')
    );
  }

  get isNgpInstance(): boolean {
    const apiUrl = ((environment as any)?.apiUrl || '').toLowerCase();
    const hostname = (window.location.hostname || '').toLowerCase();
    const href = (window.location.href || '').toLowerCase();
    const customer = (this.customerInfoData?.customerName || this.customerInfoData?.customer_name || '').toLowerCase();

    return (
      apiUrl.includes('ngp') ||
      hostname.includes('ngp') ||
      href.includes('ngp') ||
      customer.includes('ngp')
    );
  }
  // Table Data
  projectViewData: any[] = [];
  filteredFirstTableData: any[] = [];
  filteredSecondTableData: any[] = [];
  comparisonData = [
    { IPN: 'IPN1', QTY: 10, Make: 'Edit', Supplier: 'Edit', Stock: 'Edit' },
    { IPN: 'IPN2', QTY: 20, Make: 'Edit', Supplier: 'Edit', Stock: 'Edit' },
  ];

  // Reference to mat-tab-group for direct access
  @ViewChild('tabGroup', { static: false }) tabGroup!: MatTabGroup;

  displayedColumns = ['IPN', 'QTY', 'Make', 'Supplier', 'Stock']; // Add other columns here
  // Dropdown options
  form!: FormGroup;

  // Upload / mapping related
  uploadedHeaders: string[] = [];
  fieldMapping: any = {};
  reverseFieldMapping: any = {};
  data: any[] = [];
  dataProp: any[] = [];
  sourceListData: any[] = [];
  avdData: any[] = [];
  finalDataList: any[] = [];
  finalCompareDataList: any[] = [];
  sourcingListFileName: string = '';
  alternatePartFileName: string = '';
  isHeaderMappingRequired: boolean = false;
  headerErrorMessage: string = '';
  isUploadEnabled: boolean = false;
  isUploading: boolean = false;

  // For upload compare flow
  matchedCustomerData: any[] = [];
  manufacturerOverrideMap: any = {};
  allManufacturerDetailsMap: any = {};
  selectedManufacturerMap: any = {};
  isDropdownVisible: any = {};
  buttonColorMap: any = {};
  buttonBorderStyle: any = {};
  showDropdownMap: any = {};

  tableHeaders = [
    { key: 'customerPartNumber', label: 'Customer Part No.' },
    { key: 'internalPartNo', label: 'Internal Part No.' },
    { key: 'description', label: 'Description' },
    { key: 'specification', label: 'Specification' },
    { key: 'commodity', label: 'Commodity' },
    { key: 'manufacturer', label: 'Manufacturer(Mfg)' },
    { key: 'uom', label: 'UOM' },
    { key: 'projectQty', label: 'Project qty' },
    { key: 'iSourcing', label: 'I Sourcing' },
  ];

  expectedFields = [
    { key: 'customerPartNumber', label: 'Customer Part No.' },
    { key: 'internalPartNo', label: 'Internal Part No.' },
    { key: 'description', label: 'Description' },
    { key: 'specification', label: 'Specification' },
    { key: 'commodity', label: 'Commodity' },
    { key: 'manufacturer', label: 'Manufacturer(Mfg)' },
    { key: 'uom', label: 'UOM' },
    { key: 'projectQty', label: 'Project qty' },
    { key: 'iSourcing', label: 'I Sourcing' },
  ];

  // Search controls for Preview table
  showSearch: boolean = false;
  showSearchRow: boolean[] = [];
  searchValues: string[] = [];

  selectedProjectId: any;
  selectedVersionId: any = null;
  options = [];
  firstSubOptions: string[] = [];
  secondSubOptions: string[] = [];
  id: number = 1;
  selectedFirstOption: string = "";
  selectedSecondOption: string = "";
  selectedFirstSubOption: string = "";
  selectedSecondSubOption: string = "";
  errorMessage: string = '';
  userRole: any = '';
  highlightedIPN: string | null = null;
  fromAnalysisManager: boolean = false;


  project_id: any = null;
  version_id: number = 1;
  userId: any;
  role: any;
  finalConvertedData: any = [];
  projectName: string = '';
  modalRef: NgbModalRef | null = null;
  closeResult: string = '';
  customerInfoData: any;
  dasboardMatchedData: any;
  progressPercentage: string = '0';
  highlightedIpn: string | null = null;
  totalSum: number = 0;
  partsExceptNA: number = 0;
  uniquePartsCount: number = 0;
  uniquePartsSize: number = 0;
  partsExceptNACompare: number = 0;
  totalSuminCompare: number = 0;
  uniquePartsWith: number = 0;
  partsExceptNAWith: number = 0;
  totalSuminwith: number = 0;
  htmlContent!: SafeHtml;
  cleanedResHTML: string = '';
  highlightNA: boolean = false;
  partsNA: number = 0;
  filteredData: any[] = [];
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  searchFilters: {
    manufacturer: string;
    commodity: string;
    supplier: string;
  } = {
    manufacturer: '',
    commodity: '',
    supplier: ''
  };
  isSearchOpen: {
    manufacturer: boolean;
    commodity: boolean;
    supplier: boolean;
  } = {
    manufacturer: false,
    commodity: false,
    supplier: false
  };
  isMarkupMode: boolean = false;
  originalPercentMap: { [key: string]: number } = {};
  // Map to store per-row percentage values keyed by a stable row identifier
  percentMap: { [key: string]: number } = {};
  originalLandingCostMap: { [key: string]: number } = {};
  landingCostMap: { [key: string]: number } = {};
  originalUnitSellingPriceMap: { [key: string]: number } = {};
  unitSellingPriceMap: { [key: string]: number } = {};
  originalTotalSellingValueMap: { [key: string]: number } = {};
  totalSellingValueMap: { [key: string]: number } = {};



  showRFQCheckboxes = false;
  rfqSelected: any = {};
  showFetch = false;
  selectedPartsPayload: any[] = [];
  supplystatetabtype: string = '';
  shouldScrollToHighlight = false;
  showEditIcons = false;
  editingRow: any = null;
  editRowIndex: number = -1
  editableRow: any = {};

  // Trigger Sourcing mode
  showTriggerCheckboxes = false;
  showTriggerSourcingBtn = false;
  triggerSelected: any = {};
  isTriggerSourcing = false;

  // Tab management
  selectedTabIndex: number = 0;
  isInHighlightMode: boolean = false;  // Flag to track if we're highlighting a part
  currencyFilter: string | null = null;  // Currency filter from currency chart click
  vendorFilter: string | null = null;  // Vendor filter from vendor table click
  cameFromSourceBoardLink: boolean = false;  // Tracks Source Board -> Supply Sense navigation

  // Compare tab properties
  compareStageType: string = 'Costing';  // 'Costing' or 'Procurement'
  withStageType: string = 'Costing';     // 'Costing' or 'Procurement'
  compareVersionId: number = 1;
  withVersionId: number = 1;
  availableVersions: number[] = [1];     // Array of available versions for dropdown
  availableProcurementVersions: number[] = [];  // Procurement versions for compare tab

  // Track if navigated from procurement tab
  fromProcurement: boolean = false;
  procurement_version_id: number = 0;
  displayVersionLabel: string = '';  // Version label for header

  // MPN Sourcing Info Modal details
  selectedIpnForInfo: string = '';
  selectedMpnForInfo: string = '';
  selectedMfgForInfo: string = '';
  isLoadingIpnInfo: boolean = false;
  ipnInfoRelationships: any[] = [];
  ipnInfoMpnCount: number = 0;
  ipnInfoMfgCount: number = 0;
  projectRelationships: any[] = [];

  // Store intended tab index for reliable restoration after view init
  private _restoringTabIndex: number | null = null;

  ngOnInit(): void {
    console.log("═══════════════════════════════════════════════════════════════");
    console.log("🟢 PROJECT-VIEW ngOnInit STARTED");
    console.log("═══════════════════════════════════════════════════════════════");

    // STEP 1: Check and handle navigation state (TAB SWITCHING + HIGHLIGHTING)
    this.processNavigationState();

    // Check if coming from analysis-manager
    const navigationState = history.state;
    if (navigationState?.fromAnalysisManager) {
      this.fromAnalysisManager = true;
      console.log("📍 Arrived from Analysis Manager");
    }

    // STEP 2: Initialize other component data
    const detectPartInfo = history.state?.detectPartInfo;
    if (detectPartInfo) {
      this.highlightedIPN =
        history.state?.highlightedIPN ||
        sessionStorage.getItem('internalPartNo');
      this.shouldScrollToHighlight = true;
    } else if (!history.state?.highlightedPartNo) {
      this.highlightedIPN = null;
      this.shouldScrollToHighlight = false;
    }

    this.userId = sessionStorage.getItem('user_id');
    this.role = sessionStorage.getItem('role');
    this.userRole = this.roleService.getUserRole();

    // initialize upload form
    this.form = this.f_builder.group({
      source_file_name: [''],
      sourcingListFileName: [''],
      alternatePartFileName: ['']
    });

    // init search arrays (for Preview table)
    this.showSearchRow = new Array(this.tableHeaders.length).fill(false);
    this.searchValues = new Array(this.tableHeaders.length).fill('');

    // STEP 3: Load data
    console.log("📊 Loading project data...");
    this.initializeAvailableVersions();
    this.getdata();
    this.fetchProjectViewData();
    this.receiveData();
    this.loadDashboardStatsFromCustomerInfo();

    // STEP 4: Apply filters and prepare for highlighting
    setTimeout(() => {
      console.log("⏱️ 500ms delay complete - applying filters");
      this.applySavedFilter(this.savedFilter);
      this.cdr.detectChanges();

      if (this.shouldScrollToHighlight) {
        console.log("⏱️ Waiting for tab and data to fully render (1000ms total)...");
        setTimeout(() => {
          console.log("🎯 Ready to scroll - finalizing everything");
          this.cdr.detectChanges();
          this.scrollToHighlightedRow();
        }, 500); // Total wait: 500+500 = 1000ms
      }
    }, 500);

    console.log("═══════════════════════════════════════════════════════════════");
  }

  /**
   * Process navigation state to determine tab index and part highlighting
   * This is called FIRST in ngOnInit to ensure tab switches immediately
   */
  processNavigationState(): void {
    console.log("🔍 Processing navigation state...");
    console.log("   - history.state exists:", !!history.state);
    if (history.state) {
      console.log("   - history.state keys:", Object.keys(history.state));
      console.log("   - highlightedPartNo:", history.state.highlightedPartNo);
      console.log("   - selectedTabIndex:", history.state.selectedTabIndex);
    }

    // Check if we have highlighted part (from analysis component click)
    if (history.state?.highlightedPartNo) {
      console.log("✓ Navigation from part click detected");
      this.isInHighlightMode = true;  // SET FLAG
      this.highlightedIPN = history.state.highlightedPartNo;
      this.shouldScrollToHighlight = history.state.scrollToHighlight !== false;
      console.log("   ✓ highlightedIPN set to:", this.highlightedIPN);
      console.log("   ✓ shouldScrollToHighlight set to:", this.shouldScrollToHighlight);
      console.log("   ✓ isInHighlightMode set to TRUE");

      // Set tab index if provided
      if (history.state.selectedTabIndex !== undefined) {
        const targetTabIndex = history.state.selectedTabIndex;
        console.log("🟡 TARGET TAB INDEX from state: ", targetTabIndex);
        this.selectedTabIndex = targetTabIndex;
        console.log("   ✓ selectedTabIndex property set to:", this.selectedTabIndex);

        // CRITICAL: Force immediate change detection
        this.cdr.detectChanges();
        console.log("   ✓ detectChanges called");
      } else {
        console.log("⚠️ selectedTabIndex NOT in state");
      }
    }
    // Check if we have currency filter (from currency chart click)
    else if (history.state?.currencyFilter) {
      console.log("✓ Navigation from currency click detected");
      this.currencyFilter = history.state.currencyFilter;
      console.log("   ✓ currencyFilter set to:", this.currencyFilter);

      // Set tab index if provided
      if (history.state.selectedTabIndex !== undefined) {
        const targetTabIndex = history.state.selectedTabIndex;
        console.log("🟡 TARGET TAB INDEX from currency state: ", targetTabIndex);
        this.selectedTabIndex = targetTabIndex;
        console.log("   ✓ selectedTabIndex property set to:", this.selectedTabIndex);

        // CRITICAL: Force immediate change detection
        this.cdr.detectChanges();
        console.log("   ✓ detectChanges called");
      }
    }
    // Check for tab restoration (returning from another page)
    else if (history.state?.selectedTabIndex !== undefined) {
      console.log("✓ Tab restoration from history state");
      this.selectedTabIndex = history.state.selectedTabIndex;
      this._restoringTabIndex = history.state.selectedTabIndex;
      this.cdr.detectChanges();
    }
  }

  /**
   * Handle tab index changes
   */
  onTabChange(newIndex: number): void {
    console.log("📋 TAB CHANGED EVENT - newIndex:", newIndex);
    this.selectedTabIndex = newIndex;

    if (newIndex === 0) {
      this.cameFromSourceBoardLink = false;
    } else if (newIndex === 2) {
      this.initializeAvailableVersions();
    }
  }

  /**
   * AfterViewInit - Switch tab to SUPPLY SENSE if highlighting
   */
  ngAfterViewInit(): void {
    console.log("💫 ngAfterViewInit called, tabGroup:", this.tabGroup);

    if (this.isInHighlightMode) {
      console.log("🔄 Switching to SUPPLY SENSE tab (index 1) - isInHighlightMode is TRUE");
      console.log("   Current selectedTabIndex:", this.selectedTabIndex);

      // Always set to ensure the tab actually switches
      if (this.tabGroup) {
        console.log("   tabGroup exists, setting selectedIndex to 1");
        this.tabGroup.selectedIndex = 1;
        this.selectedTabIndex = 1;
        this.cdr.detectChanges();
        console.log(" Tab switched to index 1 via tabGroup.selectedIndex");
      } else {
        console.log("   ⚠️ tabGroup is null/undefined");
        this.selectedTabIndex = 1;
        this.cdr.detectChanges();
        console.log("✅ Tab switched to index 1 via property binding");
      }
    } else if (this._restoringTabIndex !== null && this._restoringTabIndex > 0) {
      // Restore tab when returning from another page (e.g., mergedata)
      console.log("🔄 Restoring tab index to:", this._restoringTabIndex);
      if (this.tabGroup) {
        this.tabGroup.selectedIndex = this._restoringTabIndex;
      }
      this.selectedTabIndex = this._restoringTabIndex;
      this._restoringTabIndex = null;
      this.cdr.detectChanges();
    } else {
      console.log("   ℹ️ isInHighlightMode is FALSE - not switching tab");
    }
  }

  savedFilter: string = 'all';

  applySavedFilter(filterType?: string) {
    if (filterType) {
      this.savedFilter = filterType;
    }
    this.applySupplySenseFilters();
  }

  /**
   * Toggle display of percent columns
   */
  togglePercentColumns(): void {
    this.toggleMarkupColumns();
  }

  /**
   * Stable key for a row used in percentMap
   */
  getRowKey(row: any): string {
    return (row?.internalPartNo || row?.internal_part_no || row?.MPN || row?.id || row?._id || JSON.stringify(row)).toString();
  }

  /**
   * Prevents typing minus or negative exponential inputs into profit margin field
   */
  preventNegativeInput(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'Minus' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
      this.notify.warning('Negative values are not allowed in % Profit Margin.', 'Warning');
    }
  }

  onPercentChange(row: any): void {
    const key = this.getRowKey(row);
    const rawVal = this.percentMap[key];
    const numVal = Number(rawVal);

    if (rawVal !== undefined && rawVal !== null && (numVal < 0 || String(rawVal).includes('-'))) {
      this.percentMap[key] = 0;
      this.notify.warning('Negative values are not allowed in % Profit Margin.', 'Warning');
    } else {
      this.percentMap[key] = isNaN(numVal) ? 0 : numVal;
    }

    if (this.isNgpInstance) {
      const margin = Number(this.percentMap[key] || 0);
      const landingCost = Number(row?.landing_cost ?? 0);
      const newUnitSelling = +(landingCost * (1 + margin / 100)).toFixed(2);
      this.unitSellingPriceMap[key] = newUnitSelling;
      row.unit_selling_price = newUnitSelling;
      row.unitSellingPrice = newUnitSelling;

      const quantity = Number(row?.projectQty ?? 0);
      const spq = Number(row?.Closest_Quantity ?? 0);
      const moq = Number(row?.MOQ ?? 0);
      const maxQty = Math.max(quantity, moq, spq);
      const effectiveQty = maxQty > 0 ? maxQty : 1;
      const calculatedTotal = +(effectiveQty * newUnitSelling).toFixed(2);
      this.totalSellingValueMap[key] = calculatedTotal;
      row.total_selling_price = calculatedTotal;
      row.totalSellingPrice = calculatedTotal;
    }

    // trigger change detection if needed
    try { this.cdr.detectChanges(); } catch (e) { }
  }

  onLandingCostChange(row: any): void {
    const key = this.getRowKey(row);
    const rawVal = this.landingCostMap[key];
    const numVal = Number(rawVal);

    if (rawVal !== undefined && rawVal !== null && (numVal < 0 || String(rawVal).includes('-'))) {
      this.landingCostMap[key] = 0;
      this.notify.warning('Negative values are not allowed in Est.Landing Cost.', 'Warning');
    } else {
      this.landingCostMap[key] = isNaN(numVal) ? 0 : numVal;
    }

    try { this.cdr.detectChanges(); } catch (e) { }
  }

  onUnitSellingPriceChange(row: any): void {
    const key = this.getRowKey(row);
    const rawVal = this.unitSellingPriceMap[key];
    const numVal = Number(rawVal);

    if (rawVal !== undefined && rawVal !== null && (numVal < 0 || String(rawVal).includes('-'))) {
      this.unitSellingPriceMap[key] = 0;
      this.notify.warning('Negative values are not allowed in Unit Selling Price.', 'Warning');
    } else {
      this.unitSellingPriceMap[key] = isNaN(numVal) ? 0 : numVal;
    }

    if (this.isNgpInstance) {
      const quantity = Number(row?.projectQty ?? 0);
      const spq = Number(row?.Closest_Quantity ?? 0);
      const moq = Number(row?.MOQ ?? 0);
      const maxQty = Math.max(quantity, moq, spq);
      const effectiveQty = maxQty > 0 ? maxQty : 1;
      const unitSelling = Number(this.unitSellingPriceMap[key] || 0);
      const calculatedTotal = +(effectiveQty * unitSelling).toFixed(2);
      this.totalSellingValueMap[key] = calculatedTotal;
      row.unit_selling_price = unitSelling;
      row.unitSellingPrice = unitSelling;
      row.total_selling_price = calculatedTotal;
      row.totalSellingPrice = calculatedTotal;

      const landingCost = Number(row?.landing_cost ?? 0);
      if (landingCost > 0) {
        const margin = +(((unitSelling - landingCost) / landingCost) * 100).toFixed(2);
        this.percentMap[key] = margin >= 0 ? margin : 0;
      }
    }

    try { this.cdr.detectChanges(); } catch (e) { }
  }

  onTotalSellingValueChange(row: any): void {
    const key = this.getRowKey(row);
    const rawVal = this.totalSellingValueMap[key];
    const numVal = Number(rawVal);

    if (rawVal !== undefined && rawVal !== null && (numVal < 0 || String(rawVal).includes('-'))) {
      this.totalSellingValueMap[key] = 0;
      this.notify.warning('Negative values are not allowed in Total Selling Value.', 'Warning');
    } else {
      this.totalSellingValueMap[key] = isNaN(numVal) ? 0 : numVal;
    }

    try { this.cdr.detectChanges(); } catch (e) { }
  }

  /**
   * Alias used by the Mark-up button — toggles edit mode and backups original values
   */
  toggleMarkupColumns(): void {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }
    this.isMarkupMode = !this.isMarkupMode;
    if (this.isMarkupMode) {
      this.originalPercentMap = { ...this.percentMap };
      this.originalLandingCostMap = { ...this.landingCostMap };
      this.originalUnitSellingPriceMap = { ...this.unitSellingPriceMap };
      this.originalTotalSellingValueMap = { ...this.totalSellingValueMap };
      // Ensure all rows have a numeric value initialized in maps
      (this.filteredData || []).forEach(row => {
        const key = this.getRowKey(row);
        if (this.percentMap[key] === undefined) {
          const initVal = Number(row?.selling_percentage ?? row?.sellingPercentage ?? 0);
          this.percentMap[key] = initVal < 0 ? 0 : initVal;
        }
        if (this.landingCostMap[key] === undefined) {
          const initLanding = Number(row?.landing_cost ?? row?.unit_selling_price ?? 0);
          this.landingCostMap[key] = isNaN(initLanding) || initLanding < 0 ? 0 : initLanding;
        }
        if (this.unitSellingPriceMap[key] === undefined) {
          const initUnit = Number(row?.unit_selling_price ?? row?.unitSellingPrice ?? row?.landing_cost ?? 0);
          this.unitSellingPriceMap[key] = isNaN(initUnit) || initUnit < 0 ? 0 : initUnit;
        }
        if (this.totalSellingValueMap[key] === undefined || this.isNgpInstance) {
          let initTotal = 0;
          if (this.isNgpInstance) {
            const quantity = Number(row?.projectQty ?? 0);
            const spq = Number(row?.Closest_Quantity ?? 0);
            const moq = Number(row?.MOQ ?? 0);
            const maxQty = Math.max(quantity, moq, spq);
            const effectiveQty = maxQty > 0 ? maxQty : 1;
            initTotal = +(this.unitSellingPriceMap[key] * effectiveQty).toFixed(2);
          } else if (row?.total_selling_price !== undefined && row?.total_selling_price !== null && row?.total_selling_price !== '') {
            initTotal = Number(row.total_selling_price);
          } else if (row?.totalSellingPrice !== undefined && row?.totalSellingPrice !== null && row?.totalSellingPrice !== '') {
            initTotal = Number(row.totalSellingPrice);
          } else if (row?.total_selling_value !== undefined && row?.total_selling_value !== null && row?.total_selling_value !== '') {
            initTotal = Number(row.total_selling_value);
          } else if (row?.totalSellingValue !== undefined && row?.totalSellingValue !== null && row?.totalSellingValue !== '') {
            initTotal = Number(row.totalSellingValue);
          } else if (!this.isAucukumServer) {
            const quantity = Number(row?.projectQty ?? 0);
            const spq = Number(row?.Closest_Quantity ?? 0);
            const maxQty = Math.max(quantity, spq);
            const effectiveQty = maxQty > 0 ? maxQty : 1;
            initTotal = this.unitSellingPriceMap[key] * effectiveQty;
          }
          this.totalSellingValueMap[key] = isNaN(initTotal) || initTotal < 0 ? 0 : initTotal;
        }
      });
    }
  }

  cancelMarkupChanges(): void {
    this.percentMap = { ...this.originalPercentMap };
    this.landingCostMap = { ...this.originalLandingCostMap };
    this.unitSellingPriceMap = { ...this.originalUnitSellingPriceMap };
    this.totalSellingValueMap = { ...this.originalTotalSellingValueMap };
    this.isMarkupMode = false;
  }

  onPriceExcelUpload(event: any): void {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) {
      return;
    }

    const file = target.files[0];
    const reader: FileReader = new FileReader();

    reader.readAsBinaryString(file);
    reader.onload = (e: any) => {
      try {
        const binarystr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

        // Prefer 'QF' sheet if present (NGP Quotation Form), otherwise the first sheet
        const wsname: string = wb.SheetNames.includes('QF') ? 'QF' : wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        if (!ws) {
          this.notify.warning('The uploaded Excel file has no readable sheet.', 'Upload Warning');
          target.value = '';
          return;
        }

        // Get 2D array representation to detect headers anywhere in the sheet
        const rawRows: any[][] = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
        if (!rawRows || rawRows.length === 0) {
          this.notify.warning('The uploaded sheet is empty.', 'Upload Warning');
          target.value = '';
          return;
        }

        // Locate header row & column indices
        let headerRowIndex = -1;
        let ipnColIndex = -1;
        let priceColIndex = -1;

        const normalizeHeader = (val: any) => String(val || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

        for (let r = 0; r < Math.min(rawRows.length, 25); r++) {
          const row = rawRows[r];
          if (!Array.isArray(row)) continue;

          let foundIpn = -1;
          let foundPrice = -1;

          for (let c = 0; c < row.length; c++) {
            const h = normalizeHeader(row[c]);
            if (!h) continue;

            // Check Internal Part No column
            if (
              h === 'internalpartno' ||
              h === 'internalpartnumber' ||
              h === 'internalpart' ||
              h === 'partnumber' ||
              h === 'partno' ||
              h === 'ipn' ||
              h.includes('internalpart')
            ) {
              foundIpn = c;
            }

            // Check Unit Selling Price column
            if (
              h === 'unitsellingprice' ||
              h === 'unitsellingpriceinr' ||
              h === 'unitselling' ||
              h === 'unitprice' ||
              h === 'unitpriceinr' ||
              h === 'sellingprice' ||
              h === 'sellingpriceinr' ||
              h.includes('unitselling') ||
              h.includes('unitprice')
            ) {
              foundPrice = c;
            }
          }

          if (foundIpn !== -1 && foundPrice !== -1) {
            headerRowIndex = r;
            ipnColIndex = foundIpn;
            priceColIndex = foundPrice;
            break;
          }
        }

        // Fallback: If exact match wasn't found, try looser check
        if (headerRowIndex === -1) {
          for (let r = 0; r < Math.min(rawRows.length, 25); r++) {
            const row = rawRows[r];
            if (!Array.isArray(row)) continue;

            let foundIpn = -1;
            let foundPrice = -1;

            for (let c = 0; c < row.length; c++) {
              const h = normalizeHeader(row[c]);
              if (!h) continue;

              if (foundIpn === -1 && (h.includes('part') || h.includes('ipn'))) {
                foundIpn = c;
              }
              if (foundPrice === -1 && (h.includes('selling') || h.includes('price') || h.includes('rate'))) {
                foundPrice = c;
              }
            }

            if (foundIpn !== -1 && foundPrice !== -1) {
              headerRowIndex = r;
              ipnColIndex = foundIpn;
              priceColIndex = foundPrice;
              break;
            }
          }
        }

        if (headerRowIndex === -1 || ipnColIndex === -1 || priceColIndex === -1) {
          this.notify.warning(
            'Could not find columns for Internal Part No and Unit Selling Price. Please check the Excel column headers.',
            'Header Warning'
          );
          target.value = '';
          return;
        }

        let updatedCount = 0;
        const partsSet = new Set<any>();
        (this.finalConvertedData || []).forEach((p: any) => partsSet.add(p));
        (this.filteredData || []).forEach((p: any) => partsSet.add(p));
        const allParts = Array.from(partsSet);

        for (let r = headerRowIndex + 1; r < rawRows.length; r++) {
          const rowData = rawRows[r];
          if (!rowData || !rowData.length) continue;

          const rawIpn = String(rowData[ipnColIndex] || '').trim();
          const rawPrice = rowData[priceColIndex];

          if (!rawIpn || rawPrice === undefined || rawPrice === null || rawPrice === '') continue;

          const cleanPriceStr = String(rawPrice).replace(/[^\d.-]/g, '');
          const priceNum = Number(cleanPriceStr);
          if (isNaN(priceNum) || priceNum < 0) continue;

          const normTargetIpn = rawIpn.toLowerCase();

          // Find matching parts in the project
          const matchedRows = allParts.filter((item: any) => {
            const itemIpn = String(
              item?.internalPartNo ||
              item?.internal_part_no ||
              item?.['Internal Part No.'] ||
              item?.['Internal Part No'] ||
              item?.internalPartNumber ||
              item?.IPN ||
              item?.ipn ||
              ''
            ).trim().toLowerCase();
            const itemMpn = String(
              item?.MPN ||
              item?.['MPN(Match)'] ||
              item?.specification ||
              item?.mpn ||
              ''
            ).trim().toLowerCase();
            return (itemIpn && itemIpn === normTargetIpn) || (itemMpn && itemMpn === normTargetIpn);
          });

          if (matchedRows.length > 0) {
            matchedRows.forEach((matchedRow: any) => {
              const key = this.getRowKey(matchedRow);
              this.unitSellingPriceMap[key] = priceNum;
              matchedRow.unit_selling_price = priceNum;
              matchedRow.unitSellingPrice = priceNum;

              if (this.isAucukumServer) {
                matchedRow.landing_cost = priceNum;
                this.landingCostMap[key] = priceNum;
              }

              // Calculate Total Selling Value
              const quantity = Number(matchedRow?.projectQty ?? matchedRow?.quantity ?? matchedRow?.qty ?? 0);
              const spq = Number(matchedRow?.Closest_Quantity ?? 0);
              const moq = Number(matchedRow?.MOQ ?? 0);

              let effectiveQty: number;
              if (this.isNgpInstance) {
                const maxQty = Math.max(quantity, moq, spq);
                effectiveQty = maxQty > 0 ? maxQty : 1;
              } else {
                const maxQty = Math.max(quantity, spq);
                effectiveQty = maxQty > 0 ? maxQty : 1;
              }

              const calculatedTotal = +(effectiveQty * priceNum).toFixed(2);
              this.totalSellingValueMap[key] = calculatedTotal;
              matchedRow.total_selling_price = calculatedTotal;
              matchedRow.totalSellingPrice = calculatedTotal;

              // Calculate % Profit Margin if cost is available
              const cost = Number(matchedRow?.landing_cost || matchedRow?.ConvertedPrice || matchedRow?.Price || 0);
              if (cost > 0) {
                const margin = +(((priceNum - cost) / cost) * 100).toFixed(2);
                this.percentMap[key] = margin >= 0 ? margin : 0;
              }

              updatedCount++;
            });
          }
        }

        target.value = '';
        try { this.cdr.detectChanges(); } catch (e) { }

        if (updatedCount > 0) {
          this.notify.success(
            `Unit selling price applied for ${updatedCount} part(s). Click Save to persist.`,
            'Price Upload Success'
          );
        } else {
          this.notify.warning(
            'No matching part numbers found in the uploaded file.',
            'No Matches Found'
          );
        }
      } catch (err) {
        console.error('Error parsing uploaded price excel:', err);
        target.value = '';
        this.notify.danger('An error occurred while reading the uploaded Excel file.', 'Error');
      }
    };

    reader.onerror = (err) => {
      console.error('FileReader error:', err);
      target.value = '';
      this.notify.danger('Failed to read the selected file.', 'Error');
    };
  }

  saveMarkupChanges(): void {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }

    const rowsToProcess: any[] = (this.finalConvertedData && this.finalConvertedData.length > 0)
      ? this.finalConvertedData
      : (this.filteredData || []);

    const hasNegativePercent = rowsToProcess.some((row: any) => {
      const key = this.getRowKey(row);
      return Number(this.percentMap[key]) < 0;
    });

    if (hasNegativePercent) {
      this.notify.warning('Negative values are not allowed in % Profit Margin.', 'Warning');
      return;
    }

    if (this.isAucukumServer || this.isNgpInstance) {
      if (this.isAucukumServer) {
        const hasNegativeLanding = rowsToProcess.some((row: any) => {
          const key = this.getRowKey(row);
          return Number(this.landingCostMap[key]) < 0;
        });

        if (hasNegativeLanding) {
          this.notify.warning('Negative values are not allowed in Est.Landing Cost.', 'Warning');
          return;
        }
      }

      const hasNegativeUnitSelling = rowsToProcess.some((row: any) => {
        const key = this.getRowKey(row);
        return Number(this.unitSellingPriceMap[key]) < 0;
      });

      if (hasNegativeUnitSelling) {
        this.notify.warning('Negative values are not allowed in Unit Selling Price.', 'Warning');
        return;
      }

      const hasNegativeTotalSelling = rowsToProcess.some((row: any) => {
        const key = this.getRowKey(row);
        return Number(this.totalSellingValueMap[key]) < 0;
      });

      if (hasNegativeTotalSelling) {
        this.notify.warning('Negative values are not allowed in Total Selling Value.', 'Warning');
        return;
      }
    }

    const updatedPayloads: any[] = [];
    const processedKeys = new Set<string>();

    rowsToProcess.forEach((row: any) => {
      const key = this.getRowKey(row);
      if (processedKeys.has(key)) return;
      processedKeys.add(key);
      const currentPercent = Math.max(0, Number(this.percentMap[key]) || 0);
      const originalPercent = Number(this.originalPercentMap[key]) || 0;

      const currentLandingCost = Math.max(0, Number(this.landingCostMap[key]) || 0);
      const originalLandingCost = Number(this.originalLandingCostMap[key]) || 0;

      const currentUnitSelling = Math.max(0, Number(this.unitSellingPriceMap[key]) || 0);
      const originalUnitSelling = Number(this.originalUnitSellingPriceMap[key]) || 0;

      const currentTotalSelling = Math.max(0, Number(this.totalSellingValueMap[key]) || 0);
      const originalTotalSelling = Number(this.originalTotalSellingValueMap[key]) || 0;

      const percentChanged = currentPercent !== originalPercent;
      const landingCostChanged = this.isAucukumServer && (currentLandingCost !== originalLandingCost);
      const unitSellingChanged = (this.isAucukumServer || this.isNgpInstance) && (currentUnitSelling !== originalUnitSelling);
      const totalSellingChanged = (this.isAucukumServer || this.isNgpInstance) && (currentTotalSelling !== originalTotalSelling);

      if (percentChanged || landingCostChanged || unitSellingChanged || totalSellingChanged) {
        if (this.isAucukumServer || this.isNgpInstance) {
          // Send edited Unit Selling Price and Total Selling Value directly
          const unitSellingPrice = this.unitSellingPriceMap[key] !== undefined ? Number(this.unitSellingPriceMap[key]) : Number(row?.unit_selling_price ?? row?.landing_cost ?? 0);
          
          let totalSellingPrice = 0;
          if (this.isNgpInstance) {
            totalSellingPrice = this.calculatePercentValue(row);
          } else if (this.totalSellingValueMap[key] !== undefined) {
            totalSellingPrice = Number(this.totalSellingValueMap[key]);
          } else if (row?.total_selling_price !== undefined && row?.total_selling_price !== null && row?.total_selling_price !== '') {
            totalSellingPrice = Number(row.total_selling_price);
          } else if (row?.totalSellingPrice !== undefined && row?.totalSellingPrice !== null && row?.totalSellingPrice !== '') {
            totalSellingPrice = Number(row.totalSellingPrice);
          } else if (row?.total_selling_value !== undefined && row?.total_selling_value !== null && row?.total_selling_value !== '') {
            totalSellingPrice = Number(row.total_selling_value);
          } else if (row?.totalSellingValue !== undefined && row?.totalSellingValue !== null && row?.totalSellingValue !== '') {
            totalSellingPrice = Number(row.totalSellingValue);
          } else {
            totalSellingPrice = 0;
          }

          // Optimistically update the local row object so the table displays the new value immediately
          row.unit_selling_price = unitSellingPrice;
          row.unitSellingPrice = unitSellingPrice;
          row.total_selling_price = totalSellingPrice;
          row.totalSellingPrice = totalSellingPrice;
          if (this.isAucukumServer) {
            row.landing_cost = unitSellingPrice;
            this.landingCostMap[key] = unitSellingPrice;
          }
          this.unitSellingPriceMap[key] = unitSellingPrice;
          this.totalSellingValueMap[key] = totalSellingPrice;

          updatedPayloads.push({
            project_id: Number(this.project_id || 0),
            version_id: Number(this.version_id || 0),
            procurement_version_id: this.fromProcurement ? Number(this.procurement_version_id || 0) : 0,
            internalPartNo: row?.internalPartNo || '',
            MPN: row?.MPN || '',
            selling_percentage: currentPercent,
            unit_selling_price: unitSellingPrice,
            total_selling_price: totalSellingPrice
          });
        } else {
          // In remaining servers: keep previous payload logic
          updatedPayloads.push({
            project_id: Number(this.project_id || 0),
            version_id: Number(this.version_id || 0),
            procurement_version_id: this.fromProcurement ? Number(this.procurement_version_id || 0) : 0,
            internalPartNo: row?.internalPartNo || '',
            MPN: row?.MPN || '',
            selling_percentage: currentPercent,
            unit_selling_price: this.calculateUnitSellingPrice(row),
            total_selling_price: this.calculatePercentValue(row)
          });
        }
      }
    });

    if (updatedPayloads.length === 0) {
      this.notify.info('No changes to save.');
      this.isMarkupMode = false;
      return;
    }

    console.log('Saving markup updates:', updatedPayloads);
    this.isLoading = true;

    let completedCount = 0;
    let successCount = 0;

    updatedPayloads.forEach(payload => {
      this.masterService.UpdateProjectPartMargin(payload).subscribe({
        next: (res: any) => {
          successCount++;
          completedCount++;
          if (completedCount === updatedPayloads.length) {
            this.handleSaveComplete(successCount, updatedPayloads.length);
          }
        },
        error: (err: any) => {
          completedCount++;
          console.error('Error saving margin for part:', payload.internalPartNo, err);
          if (completedCount === updatedPayloads.length) {
            this.handleSaveComplete(successCount, updatedPayloads.length);
          }
        }
      });
    });
  }

  private handleSaveComplete(successCount: number, totalCount: number): void {
    this.isLoading = false;
    this.isMarkupMode = false;
    this.originalPercentMap = { ...this.percentMap };
    this.originalLandingCostMap = { ...this.landingCostMap };
    this.originalUnitSellingPriceMap = { ...this.unitSellingPriceMap };
    this.originalTotalSellingValueMap = { ...this.totalSellingValueMap };

    if (successCount === totalCount) {
      this.notify.success(`Successfully saved markup for all ${totalCount} parts.`);
    } else {
      this.notify.warning(`Saved markup for ${successCount} of ${totalCount} parts. Check console for errors.`);
    }

    this.getdata();
  }

  initializePercentMap(): void {
    if (this.finalConvertedData) {
      this.finalConvertedData.forEach((item: any) => {
        const key = this.getRowKey(item);
        this.percentMap[key] = Number(item.selling_percentage ?? item.sellingPercentage ?? 0);
        let landingVal = 0;
        if (this.isAucukumServer) {
          if (item.unit_selling_price !== undefined && item.unit_selling_price !== null && item.unit_selling_price !== '') {
            landingVal = Number(item.unit_selling_price);
          } else if (item.unitSellingPrice !== undefined && item.unitSellingPrice !== null && item.unitSellingPrice !== '') {
            landingVal = Number(item.unitSellingPrice);
          } else if (item.landing_cost !== undefined && item.landing_cost !== null && item.landing_cost !== '') {
            landingVal = Number(item.landing_cost);
          }
        } else {
          landingVal = Number(item.landing_cost ?? 0);
        }
        this.landingCostMap[key] = isNaN(landingVal) ? 0 : landingVal;
        if (this.isAucukumServer) {
          item.landing_cost = this.landingCostMap[key];
        }

        // Initialize unit selling price and total selling value
        let unitSellingVal = 0;
        if (item.unit_selling_price !== undefined && item.unit_selling_price !== null && item.unit_selling_price !== '') {
          unitSellingVal = Number(item.unit_selling_price);
        } else if (item.unitSellingPrice !== undefined && item.unitSellingPrice !== null && item.unitSellingPrice !== '') {
          unitSellingVal = Number(item.unitSellingPrice);
        } else if (item.landing_cost !== undefined && item.landing_cost !== null && item.landing_cost !== '') {
          unitSellingVal = Number(item.landing_cost);
        }
        this.unitSellingPriceMap[key] = isNaN(unitSellingVal) ? 0 : unitSellingVal;

        let totalSellingVal = 0;
        if (this.isNgpInstance) {
          const qty = Number(item.projectQty || 0);
          const spq = Number(item.Closest_Quantity || 0);
          const moq = Number(item.MOQ || 0);
          const maxQty = Math.max(qty, moq, spq);
          const effectiveQty = maxQty > 0 ? maxQty : 1;
          totalSellingVal = +(unitSellingVal * effectiveQty).toFixed(2);
        } else if (item.total_selling_price !== undefined && item.total_selling_price !== null && item.total_selling_price !== '') {
          totalSellingVal = Number(item.total_selling_price);
        } else if (item.totalSellingPrice !== undefined && item.totalSellingPrice !== null && item.totalSellingPrice !== '') {
          totalSellingVal = Number(item.totalSellingPrice);
        } else if (item.total_selling_value !== undefined && item.total_selling_value !== null && item.total_selling_value !== '') {
          totalSellingVal = Number(item.total_selling_value);
        } else if (item.totalSellingValue !== undefined && item.totalSellingValue !== null && item.totalSellingValue !== '') {
          totalSellingVal = Number(item.totalSellingValue);
        } else if (!this.isAucukumServer) {
          const qty = Number(item.projectQty || 0);
          const spq = Number(item.Closest_Quantity || 0);
          const maxQty = Math.max(qty, spq);
          const effectiveQty = maxQty > 0 ? maxQty : 1;
          totalSellingVal = unitSellingVal * effectiveQty;
        }
        this.totalSellingValueMap[key] = isNaN(totalSellingVal) ? 0 : totalSellingVal;
      });
    }
  }

  calculateUnitSellingPrice(row: any): number {
    const key = this.getRowKey(row);
    if (this.isAucukumServer || this.isNgpInstance) {
      const editedUnitSellingPrice = this.unitSellingPriceMap[key];
      if (editedUnitSellingPrice !== undefined && editedUnitSellingPrice !== null && !isNaN(Number(editedUnitSellingPrice))) {
        return Number(editedUnitSellingPrice);
      }
      return Number(row?.unit_selling_price ?? row?.unitSellingPrice ?? row?.landing_cost ?? 0);
    }
    const profitMarginPercent = Number(this.percentMap[key] || 0);
    const landingCost = Number(row?.landing_cost ?? 0);
    // Unit Selling Price = landing_cost * (1 + profitMarginPercent/100)
    return +(landingCost * (1 + (profitMarginPercent / 100)));
  }

  calculatePercentValue(row: any): number {
    const key = this.getRowKey(row);
    if (this.isAucukumServer) {
      const editedTotalSellingValue = this.totalSellingValueMap[key];
      if (editedTotalSellingValue !== undefined && editedTotalSellingValue !== null && !isNaN(Number(editedTotalSellingValue))) {
        return Number(editedTotalSellingValue);
      }
      if (row?.total_selling_price !== undefined && row?.total_selling_price !== null && !isNaN(Number(row?.total_selling_price))) {
        return Number(row.total_selling_price);
      }
      if (row?.totalSellingPrice !== undefined && row?.totalSellingPrice !== null && !isNaN(Number(row?.totalSellingPrice))) {
        return Number(row.totalSellingPrice);
      }
      if (row?.total_selling_value !== undefined && row?.total_selling_value !== null && !isNaN(Number(row?.total_selling_value))) {
        return Number(row.total_selling_value);
      }
      if (row?.totalSellingValue !== undefined && row?.totalSellingValue !== null && !isNaN(Number(row?.totalSellingValue))) {
        return Number(row.totalSellingValue);
      }
      return 0;
    }
    const unitSellingPrice = this.calculateUnitSellingPrice(row);
    const quantity = Number(row?.projectQty ?? 0);
    const spq = Number(row?.Closest_Quantity ?? 0); // SPQ
    const moq = Number(row?.MOQ ?? 0);              // MOQ

    let effectiveQty: number;
    if (this.isNgpInstance) {
      // NGP: Total Selling Price = Unit Selling Price * max(qty, MOQ, SPQ)
      const maxQty = Math.max(quantity, moq, spq);
      effectiveQty = maxQty > 0 ? maxQty : 1;
    } else {
      // Other servers: max(qty, SPQ/Closest_Quantity)
      const maxQty = Math.max(quantity, spq);
      effectiveQty = maxQty > 0 ? maxQty : 1;
    }

    return +(effectiveQty * unitSellingPrice);
  }

  filterByCurrency(currency: string) {
    console.log("🔍 Filtering data by currency:", currency);
    this.currencyFilter = currency || null;
    this.applySupplySenseFilters();
    console.log("✅ Currency filter applied. Results:", this.filteredData.length, "items");
    console.log("   Filtering for currency:", currency);
  }

  onCurrencySelected(currency: string): void {
    console.log("🔔 Currency selected event received from Analysis component:", currency);

    // Apply the currency filter
    this.filterByCurrency(currency);
    this.cameFromSourceBoardLink = true;

    // Switch to the SUPPLY SENSE tab (index 1)
    this.selectedTabIndex = 1;

    if (this.tabGroup) {
      console.log("✅ Switching to SUPPLY SENSE tab via tabGroup");
      this.tabGroup.selectedIndex = 1;
    } else {
      console.log("✅ Switching to SUPPLY SENSE tab via property binding");
    }

    this.cdr.detectChanges();
    console.log("✅ Tab switched and filter applied. Currency:", currency);
  }

  onPartSelected(partNumber: string): void {
    console.log("🔔 Part selected event received from Analysis component:", partNumber);

    if (!partNumber) {
      console.warn("⚠️ Part number is empty");
      return;
    }

    // Set the highlighted part
    this.highlightedIPN = partNumber;
    console.log("✓ highlightedIPN set to:", this.highlightedIPN);

    // Enable highlighting mode
    this.isInHighlightMode = true;
    this.shouldScrollToHighlight = true;
    this.cameFromSourceBoardLink = true;

    // Apply 'all' filter to see all parts
    this.applySavedFilter('all');

    // Switch to the SUPPLY SENSE tab (index 1)
    this.selectedTabIndex = 1;

    if (this.tabGroup) {
      console.log("✅ Switching to SUPPLY SENSE tab via tabGroup to show part:", partNumber);
      this.tabGroup.selectedIndex = 1;
    } else {
      console.log("✅ Switching to SUPPLY SENSE tab via property binding");
    }

    // Force change detection
    this.cdr.detectChanges();

    // Scroll to the highlighted part after a short delay to allow rendering
    setTimeout(() => {
      console.log("🎯 Scrolling to highlighted part:", partNumber);
      this.scrollToHighlightedRow();
    }, 100);

    console.log("✅ Part highlight applied. Part:", partNumber);
  }

  filterByVendor(vendor: string) {
    console.log("🔍 Filtering data by vendor:", vendor);
    this.vendorFilter = vendor || null;
    this.applySupplySenseFilters();
    console.log("✅ Vendor filter applied. Results:", this.filteredData.length, "items");
    console.log("   Filtering for vendor:", vendor);
  }

  onVendorSelected(vendor: string): void {
    console.log("🔔 Vendor selected event received from Analysis component:", vendor);

    if (!vendor) {
      console.warn("⚠️ Vendor is empty");
      return;
    }

    // Apply the vendor filter
    this.filterByVendor(vendor);
    this.cameFromSourceBoardLink = true;

    // Switch to the SUPPLY SENSE tab (index 1)
    this.selectedTabIndex = 1;

    if (this.tabGroup) {
      console.log("✅ Switching to SUPPLY SENSE tab via tabGroup to show vendor:", vendor);
      this.tabGroup.selectedIndex = 1;
    } else {
      console.log("✅ Switching to SUPPLY SENSE tab via property binding");
    }

    this.cdr.detectChanges();
    console.log("✅ Tab switched and vendor filter applied. Vendor:", vendor);
  }

  toggleHeaderSearch(column: 'manufacturer' | 'commodity' | 'supplier', event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.isSearchOpen[column] = !this.isSearchOpen[column];
    if (this.isSearchOpen[column]) {
      setTimeout(() => {
        const inputEl = document.getElementById(`header-search-${column}`) as HTMLInputElement;
        if (inputEl) {
          inputEl.focus();
        }
      }, 50);
    }
  }

  closeHeaderSearch(column: 'manufacturer' | 'commodity' | 'supplier') {
    this.isSearchOpen[column] = false;
  }

  clearHeaderSearch(column: 'manufacturer' | 'commodity' | 'supplier', event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.searchFilters[column] = '';
    this.isSearchOpen[column] = false;
    this.applySupplySenseFilters();
  }

  applySupplySenseFilters() {
    let data = [...this.finalConvertedData];

    // 1. Saved filter: sourced / unsourced / all
    if (this.savedFilter === 'sourced') {
      data = data.filter((item: any) =>
        item.supplier && item.supplier !== 'N/A' && item.supplier !== 'NA'
      );
    } else if (this.savedFilter === 'unsourced') {
      data = data.filter((item: any) => item.supplier === 'N/A' || item.supplier === 'NA' || !item.supplier);
    }

    // 2. Currency filter if active
    if (this.currencyFilter) {
      data = data.filter((item: any) => item.Currency === this.currencyFilter);
    }

    // 3. Vendor filter if active
    if (this.vendorFilter) {
      data = data.filter((item: any) =>
        item.supplier === this.vendorFilter || item.Finalized_Supplier === this.vendorFilter
      );
    }

    // 4. Header searches: Make (manufacturer), Commodity, Finalized Supplier
    const makeQuery = (this.searchFilters.manufacturer || '').trim().toLowerCase();
    if (makeQuery) {
      data = data.filter((item: any) =>
        (item.manufacturer || '').toString().toLowerCase().includes(makeQuery)
      );
    }

    const commodityQuery = (this.searchFilters.commodity || '').trim().toLowerCase();
    if (commodityQuery) {
      data = data.filter((item: any) =>
        (item.commodity || '').toString().toLowerCase().includes(commodityQuery)
      );
    }

    const supplierQuery = (this.searchFilters.supplier || '').trim().toLowerCase();
    if (supplierQuery) {
      data = data.filter((item: any) =>
        (item.supplier || '').toString().toLowerCase().includes(supplierQuery) ||
        (item.Finalized_Supplier || '').toString().toLowerCase().includes(supplierQuery)
      );
    }

    this.filteredData = data;
    this.applySort();
  }

  sortData(column: string) {
    if (column === 'manufacturer' || column === 'commodity' || column === 'supplier') {
      return;
    }
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.applySort();
  }

  applySort() {
    if (!this.sortColumn || !this.filteredData || this.filteredData.length === 0) {
      return;
    }

    const column = this.sortColumn;
    const direction = this.sortDirection;

    this.filteredData.sort((a, b) => {
      const rawA = this.getSortValue(a, column);
      const rawB = this.getSortValue(b, column);

      const isAEmpty = rawA === null || rawA === undefined || rawA === '' || rawA === 'N/A';
      const isBEmpty = rawB === null || rawB === undefined || rawB === '' || rawB === 'N/A';

      if (isAEmpty && isBEmpty) return 0;
      if (isAEmpty) return 1;
      if (isBEmpty) return -1;

      // Check if values are numbers
      const numA = typeof rawA === 'number' ? rawA : (typeof rawA === 'string' && rawA.trim() !== '' && !isNaN(Number(rawA)) ? Number(rawA) : NaN);
      const numB = typeof rawB === 'number' ? rawB : (typeof rawB === 'string' && rawB.trim() !== '' && !isNaN(Number(rawB)) ? Number(rawB) : NaN);
      const isNumA = !isNaN(numA);
      const isNumB = !isNaN(numB);

      if (isNumA && isNumB) {
        return direction === 'asc'
          ? numA - numB
          : numB - numA;
      }

      const strA = rawA.toString().trim().toLowerCase();
      const strB = rawB.toString().trim().toLowerCase();

      return direction === 'asc'
        ? strA.localeCompare(strB, undefined, { numeric: true, sensitivity: 'base' })
        : strB.localeCompare(strA, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  getSortValue(row: any, column: string): any {
    if (!row) return null;

    switch (column) {
      case 'internalPartNo':
        return row.internalPartNo;
      case 'specification':
        return row.specification;
      case 'MPN':
        return row.MPN;
      case 'manufacturer':
        return row.manufacturer;
      case 'commodity':
        return row.commodity;
      case 'uom':
        return row.uom;
      case 'projectQty':
        return row.projectQty;
      case 'supplier':
        return row.supplier;
      case 'country':
        return row.country;
      case 'Inventorylevel':
        return row.Inventorylevel;
      case 'MOQ':
        return row.MOQ;
      case 'Closest_Quantity':
        return row.Closest_Quantity;
      case 'leadTime':
        return this.getLeadTimeToShow(row);
      case 'Price':
        return row.Price;
      case 'Currency':
        return row.Currency;
      case 'ConvertedPrice':
        return row.ConvertedPrice;
      case 'landing_cost': {
        const key = this.getRowKey(row);
        return (this.isAucukumServer && this.landingCostMap[key] !== undefined)
          ? this.landingCostMap[key]
          : row.landing_cost;
      }
      case 'moqCost':
        return this.calculateMOQCost(row);
      case 'total_value_inr':
        return row.total_value_inr;
      case 'profitMargin': {
        const key = this.getRowKey(row);
        return this.percentMap[key] || 0;
      }
      case 'unitSellingPrice':
        return this.calculateUnitSellingPrice(row);
      case 'totalSellingValue':
        return this.calculatePercentValue(row);
      case 'isPoExist':
        return row.isPoExist === 'Yes' ? 'Available' : 'No Records';
      default:
        return row[column];
    }
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return 'fa fa-sort';
    }
    return this.sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
  }

  receiveData() {
    let receiveData: any = history.state

    console.log('receiveData => ', receiveData)
    if (!!receiveData.rfqSelectedSR) {
      let rfqSelectedSR: any = typeof receiveData.rfqSelectedSR === 'string' ? JSON.parse(receiveData.rfqSelectedSR) : receiveData.rfqSelectedSR
      console.log('rfqSelectedSR => ', rfqSelectedSR);
      this.rfqSelected = rfqSelectedSR.rfqSelected;
    }

    if (!!receiveData.showRFQCheckboxes) {
      this.showRFQCheckboxes = (receiveData.showRFQCheckboxes === 'true' || receiveData.showRFQCheckboxes === true);
    }

    if (!!receiveData.showFetch) {
      this.showFetch = (receiveData.showFetch === 'true' || receiveData.showFetch === true);
    }

    if (!!receiveData.savedFilter) {
      if (receiveData.savedFilter === 'sourced') {

        this.showSourcedParts();

      }
      else if (receiveData.savedFilter === 'unsourced') {
        this.showUnsourcedParts();

      }
    }

  }

  sendDataToComponents(path: string, data: any) {
    let state: any = history.state
    this.router.navigate([path], {
      state: {
        payload: JSON.stringify(data),
        selectedTabIndex: this.selectedTabIndex,
        savedFilter: this.savedFilter,
        startIndex: state?.startIndex ?? 0,
        endIndex: state?.endIndex ?? 10,
        rowsPerPage: state?.rowsPerPage ?? 10,
        currentPage: state?.currentPage ?? 1,

      }
    });
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private masterService: MasterService,
    private roleService: RoleService,
    private notify: NbToastrService,
    private exportService: ExportService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private f_builder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this.project_id = Number(sessionStorage.getItem('project_id'));
    this.version_id = Number(sessionStorage.getItem('version_id'));

    const navigation: any = this.router.getCurrentNavigation();
    let resData: any = history.state
    if (resData.hasOwnProperty('rfqSelectedSR')) {
      resData['rfqSelectedSR'] = JSON.parse(resData['rfqSelectedSR'])
    }
    console.log('resData => ', resData)

    // Check if navigated from procurement tab
    this.fromProcurement = resData?.fromProcurement === true;
    if (this.fromProcurement) {
      this.procurement_version_id = Number(resData?.procurementVersionId || resData?.customerInfo?.procurement_version_id || 0);
      console.log('Navigated from Procurement tab, procurement_version_id:', this.procurement_version_id);
    } else {
      this.procurement_version_id = 0;
      sessionStorage.setItem('procurement_version_id', '0');
      console.log('Navigated from Costing tab or no procurement version, procurement_version_id set to 0');
    }

    let versionId = resData?.customerInfo?.version_ids === undefined ? resData?.customerInfo?.versions : resData?.customerInfo?.version_ids;
    this.firstSubOptions = versionId;
    this.secondSubOptions = versionId;


    if (resData.hasOwnProperty('customerInfo')) {
      this.customerInfoData = resData?.customerInfo;//navigation.extras.state.customerInfo;
    }
    else {
      const dashboardDataString = sessionStorage.getItem('dashboard_selected_data');

      if (dashboardDataString) {
        try {
          const dashbardSelectedData = JSON.parse(dashboardDataString);
          console.log('dashbardSelectedData => ', dashbardSelectedData);
          this.firstSubOptions = dashbardSelectedData?.version_ids === undefined ? dashbardSelectedData?.versions : dashbardSelectedData?.version_ids;
          this.secondSubOptions = dashbardSelectedData?.version_ids === undefined ? dashbardSelectedData?.versions : dashbardSelectedData?.version_ids;
          this.customerInfoData = dashbardSelectedData;
        } catch (error) {
          console.error('Error parsing dashboard_selected_data:', error);
          this.firstSubOptions = [];
          this.secondSubOptions = [];
          this.customerInfoData = {};
        }
      } else {
        console.warn('No dashboard_selected_data in sessionStorage');
        this.firstSubOptions = [];
        this.secondSubOptions = [];
        this.customerInfoData = {};
      }
    }

    this.approvalStatus = this.customerInfoData?.approval_status || sessionStorage.getItem('approval_status') || '';
    if (this.approvalStatus) {
      sessionStorage.setItem('approval_status', this.approvalStatus);
    }

    // If customerInfoData arrived with user ids, preserve them for analysis before async API response.
    const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
    const initialEngineerId = this.customerInfoData?.engineer_id ?? this.customerInfoData?.assigned_to_id ?? this.customerInfoData?.engineerId;
    let initialManagerId: any;
    if (currentUser.role_name === 'Engineer') {
      initialManagerId = currentUser.manager_id;
    } else {
      initialManagerId = this.customerInfoData?.manager_id ?? this.customerInfoData?.managerId ?? sessionStorage.getItem('user_id');
    }
    if (initialEngineerId !== undefined && initialEngineerId !== null) {
      sessionStorage.setItem('engineer_id', String(initialEngineerId));
      this.engineer_id = Number(initialEngineerId);
    }
    if (initialManagerId !== undefined && initialManagerId !== null) {
      sessionStorage.setItem('manager_id', String(initialManagerId));
      this.manager_id = Number(initialManagerId);
    }

  }

  projectCost: number = 0;
  projectStatus: string = '';
  approvalStatus: string = '';
  get isReviewStage(): boolean {
    const status = (this.approvalStatus || '').toLowerCase().trim();
    return status === 'pending - manager review' || status === 'approved';
  }
  engineer_id: number | null = null;
  manager_id: number | null = null;


  isLoading: boolean = false;
  getdata() {
    console.log(' getdata() CALLED');
    this.isLoading = true;  // Start loading
    this.loadProjectRelationships();

    let data = {
      "project_id": Number(this.project_id),
      "version_id": Number(this.version_id),
      "procurement_version_id": this.customerInfoData?.procurement_version_id ?? 0, // Get from selected project data
    };

    if (data.project_id && data.version_id) {
      this.masterService.get_ProjectviewWithProjectIdAndVersionId(data).subscribe(
        (result: any) => {

          this.isLoading = false;  // Stop loading on success
          console.log("results => ", result, result.results);
          let message = result['message'];
          let status = result['status'];
          this.projectStatus = result.results?.[0]?.status || '';
          console.log("Project Status from API:", this.projectStatus);
          sessionStorage.setItem('projectStatus', this.projectStatus);

          this.approvalStatus = result.results?.[0]?.approval_status || result.results?.[0]?.approvalStatus || this.customerInfoData?.approval_status || sessionStorage.getItem('approval_status') || '';
          sessionStorage.setItem('approval_status', this.approvalStatus);

          let data = result.results;

          console.log("get_ProjectviewWithProjectIdAndVersionId => ", data);
          if (data.length === 0) {
            this.notify.info('Sourcing data not avalible...');
            if (this.role === 'Manager') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
            } else if (this.role === 'Engineer') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-engineer']));
            } else if (this.role === 'Admin') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
            }
          }
          else if (data.length > 0) {
            let data = result.results;
            console.log('data', data);

            if (data[0]) {
              const parts = data[0].parts;
              console.log('parts', parts);
              this.finalConvertedData = parts;
              this.initializePercentMap();
              this.applySavedFilter();


              console.log("Saved Filter Applied After Data Load");

              const uniquePartNumbers = new Set(this.finalConvertedData.map((item: any) => item.internalPartNo));
              this.uniquePartsCount = uniquePartNumbers.size;

              this.partsExceptNA = this.finalConvertedData.filter((item: any) => item.supplier !== 'N/A').length;
              this.partsNA = this.finalConvertedData.filter((item: any) => item.supplier === 'N/A').length;
              this.filteredData = [...this.finalConvertedData];
              console.log('finalConvertedData', this.finalConvertedData);
              this.progressPercentage = this.calculateProgress(this.finalConvertedData);
              sessionStorage.setItem('progressPercentage', this.progressPercentage);
              const sessionKey = 'project_parts_' + this.project_id + '_' + this.version_id;
              sessionStorage.setItem(sessionKey, JSON.stringify(this.finalConvertedData));
              console.log('Progress:', this.progressPercentage + '%');

              const currencyConversionRates: { [key: string]: number } = {
                INR: 1,
                USD: 86,
                EUR: 90
              };

              if (data[0]) {
                const parts = data[0].parts;
                this.finalConvertedData = parts.map((item: any) => {
                  const qty = Math.max(item.projectQty || 0, item.Closest_Quantity || 0);
                  const basePriceINR = (item.ConvertedPrice || 0) * (item.ConversionRate || 1);
                  let landingCostInINR = item.landing_cost || 0;
                  if (this.isAucukumServer) {
                    if (item.unit_selling_price !== undefined && item.unit_selling_price !== null && item.unit_selling_price !== '') {
                      landingCostInINR = Number(item.unit_selling_price);
                    } else if (item.unitSellingPrice !== undefined && item.unitSellingPrice !== null && item.unitSellingPrice !== '') {
                      landingCostInINR = Number(item.unitSellingPrice);
                    }
                  }
                  const totalLandingCost = (landingCostInINR / (item.ConversionRate || 1)) * qty;
                  const totalCostINR = landingCostInINR * qty;
                  const conversionRate = currencyConversionRates[item.Currency] || 1;
                  const estLandingCost = (item.Price || 0) * conversionRate * 1.28;
                  const priceColor = estLandingCost > landingCostInINR ? 'green' : 'red';

                  return {
                    ...item,
                    // basic_price_in_inr: basePriceINR.toFixed(2),
                    landing_cost: landingCostInINR,
                    total_landing_cost: totalLandingCost,
                    total_value_inr: totalCostINR,
                    priceColor
                  };
                });

                this.initializePercentMap();
                this.filteredData = [...this.finalConvertedData];
                this.applySavedFilter();

                console.log("finalConvertedData => ", this.finalConvertedData);
                this.calculateProjectCost();
              }

              console.log('this.finalConvertedData', this.finalConvertedData)

              const project = data[0];
              this.project_id = project?.project_id;
              this.version_id = project?.version_id;
              this.projectName = project?.projectName;
              this.engineer_id = project?.engineer_id;

              // For engineers, use the manager_id from login user details, not from project
              const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
              if (currentUser.role_name === 'Engineer') {
                this.manager_id = currentUser.manager_id;
              } else {
                this.manager_id = project?.manager_id;
              }

              // Store engineer_id and manager_id in sessionStorage for use in analysis component
              sessionStorage.setItem('engineer_id', String(this.engineer_id || ''));
              sessionStorage.setItem('manager_id', String(this.manager_id || ''));

              console.log('Engineer ID:', this.engineer_id);
              console.log('Manager ID:', this.manager_id);
              console.log('project', project);
            }
          } else {
            console.error('Error: Unable to retrieve project data');
            this.errorMessage = 'There was an issue retrieving the project data. Please try again.';
          }
        }, (error) => {
          this.isLoading = false;  // Stop loading on error
          this.errorMessage = 'There was an issue retrieving the project data. Please try again.';
          console.error(error);
        });
    }
    else if (!this.project_id || !this.version_id || (this.project_id && !this.version_id)) {
      this.isLoading = true;  // Start loading
      const emptyParams = {};
      this.masterService.get_Projectview(emptyParams).subscribe(
        (result: any) => {
          this.isLoading = false;  // Stop loading on success
          let message = result['message'];
          let status = result['status'];
          let data = result.results;

          if (data.length === 0) {
            this.notify.info(message);
            if (this.role === 'Manager') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
            } else if (this.role === 'Engineer') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-engineer']));
            } else if (this.role === 'Admin') {
              Promise.resolve().then(() => this.router.navigate(['/dashboard-manager']));
            }
          }
          else if (data.length > 0) {
            let data = result.results;
            console.log('data', data);
            if (data[0]) {
              const parts = data[0].parts;
              console.log('parts', parts);
              this.finalConvertedData = parts;
              this.initializePercentMap();
              console.log('finalConvertedData', this.finalConvertedData);
              this.applySavedFilter();
              const project = data[0].project;
              this.project_id = project?.project_id;
              this.version_id = project?.version_id;
              this.projectName = project?.projectName;
              console.log('project', project);
            }
          } else {
            console.error('Error: Unable to retrieve project data');
            this.errorMessage = 'There was an issue retrieving the project data. Please try again.';
          }
        }, (error) => {
          this.isLoading = false;  // Stop loading on error
          this.errorMessage = 'There was an issue retrieving the project data. Please try again.';
          console.error(error);
        });
    }
    else if (!data.project_id && !data.version_id) {
      this.notify.danger('Project Id or Version Id Not Available.');
    }
  }


  enableSourceEdit() {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }
    if (this.showEditIcons) {
      // Turn off source edit mode
      this.cancelEditMode();
    } else {
      // Show confirmation popup before enabling edit mode
      this.showEditConfirmPopup = true;
    }
  }

  cancelEditMode() {
    this.showEditIcons = false;
    this.showTriggerSourcingBtn = false;
    this.showTriggerCheckboxes = false;
    this.triggerSelected = {};
    this.isCriteriaSelected = false;
    this.showDeleteCheckboxes = false;
    this.deleteSelected = {};
    this.isDeletingParts = false;
    this.editingRow = null;
    this.selectedRowForEdit = null;
    this.selectedRowIndex = -1;
    this.isManufacturerInvalid = false;
    this.manufacturerSuggestions = [];
    this.manufacturerSuggestionsCache = [];
  }
  isManufacturerInvalid: boolean = false;
  manufacturerSuggestions: string[] = [];
  manufacturerSuggestionsCache: string[] = [];
  manufacturerSearchTimeout: any = null;
  selectManufacturer(mfg: string) {
    this.editableRow.manufacturer = mfg;
    this.manufacturerSuggestions = [];
    this.isManufacturerInvalid = false;
  }

  // startRowEdit(row: any, index: number) {
  //   this.editingRow = row;
  //   this.editRowIndex = index;

  //   // deep copy
  //   this.editableRow = { ...row };

  //   // PREVIOUS MAKE BASED SEARCH
  //   if (this.editableRow.manufacturer) {
  //     this.fetchManufacturerSuggestions(this.editableRow.manufacturer);
  //   }
  // }
  startRowEdit(row: any, index: number) {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }
    this.editingRow = row;
    this.editRowIndex = index;

    // deep copy
    this.editableRow = { ...row };

    // Important: clear dropdown state
    this.manufacturerSuggestions = [];
    this.manufacturerSuggestionsCache = [];
    this.isManufacturerInvalid = false;
  }

  showEditConfirmPopup = false;
  selectedRowForEdit: any = null;
  selectedRowIndex: number = -1;
  openEditConfirmPopup(row: any, index: number) {
    this.selectedRowForEdit = row;
    this.selectedRowIndex = index;
    this.showEditConfirmPopup = true;
  }
  confirmEditWithoutClone() {
    this.showEditConfirmPopup = false;
    this.showEditIcons = true;
    this.showTriggerSourcingBtn = true;
    this.editingRow = null;
    this.selectedRowForEdit = null;
    this.selectedRowIndex = -1;
  }

  cancelEditPopup() {
    this.showEditConfirmPopup = false;
    this.showTriggerSourcingBtn = false;
    this.selectedRowForEdit = null;
    this.selectedRowIndex = -1;
  }
  fetchManufacturerSuggestions(value: string) {
    const payload = { name: value.trim() };

    this.masterService.manufacturer_Name_search(payload)
      .subscribe((res: any) => {
        this.manufacturerSuggestions = res?.matches || [];
        this.manufacturerSuggestionsCache = [...this.manufacturerSuggestions];
      }, err => {
        this.manufacturerSuggestions = [];
        this.manufacturerSuggestionsCache = [];
      });
  }



  onManufacturerInput(event: any) {
    const value = event.target.value;

    if (!value || value.length < 1) {
      this.manufacturerSuggestions = [];
      this.isManufacturerInvalid = false;
      return;
    }

    clearTimeout(this.manufacturerSearchTimeout);

    this.manufacturerSearchTimeout = setTimeout(() => {
      this.fetchManufacturerSuggestions(value);

      // After fetch, validate
      setTimeout(() => {
        this.isManufacturerInvalid =
          this.manufacturerSuggestions.length > 0 &&
          !this.manufacturerSuggestions
            .map(m => m.toLowerCase())
            .includes(value.toLowerCase());
      }, 200);

    }, 300);
  }


  isCriteriaSelected: boolean = false;
  criteria = {
    stockAvailability: false,
    leadTime: false,
    minimumPrice: false,
    authorisedSuppliers: false,
    selectedSuppliers: []
  };

  selectCriteria(criteriaModal: any) {


    this.modalRef = this.modalService.open(criteriaModal, { size: 'lg' });
  }
  openDataPref(dataPrefModal: any) {
    this.modalService.open(dataPrefModal, {
      size: 'md',
      backdrop: 'static',
      centered: true
    });
  }
  onSupplierSelectionChange() {
    if (this.criteria.selectedSuppliers && this.criteria.selectedSuppliers.length > 0) {
      this.criteria.authorisedSuppliers = true;
    }
  }

  saveModal() {
    if (this.criteria.selectedSuppliers && this.criteria.selectedSuppliers.length > 0) {
      this.criteria.authorisedSuppliers = true;
    }
    console.log('Selected Criteria =>', this.criteria);
    this.isCriteriaSelected = true;

    const rawSuppliers = this.criteria?.selectedSuppliers || [];
    const normalizedSuppliers: string[] = (Array.isArray(rawSuppliers) ? rawSuppliers : [rawSuppliers])
      .map((s: any) => {
        if (!s) return '';
        if (typeof s === 'string') return s.trim();
        if (typeof s === 'object') return (s.name || s.supplierName || s.label || '').trim();
        return String(s).trim();
      })
      .filter((s: string) => s.length > 0);

    const hasSelectedSuppliers = normalizedSuppliers.length > 0;
    const isAuthSuppliers = Boolean(this.criteria?.authorisedSuppliers || hasSelectedSuppliers);

    if (this.finalDataList && this.finalDataList.length > 0) {
      this.finalDataList = this.finalDataList.map((item: any) => ({
        ...item,
        stockAvailability: this.boolToNumber(this.criteria?.stockAvailability),
        leadTime: this.boolToNumber(this.criteria?.leadTime),
        minimumPrice: this.boolToNumber(this.criteria?.minimumPrice),
        authorisedSuppliers: isAuthSuppliers ? 1 : 0,
        suppliers: hasSelectedSuppliers
          ? normalizedSuppliers.map(s => ({ supplierName: s }))
          : []
      }));
      this.finalCompareDataList = [...this.finalDataList];
    }

    this.modalRef!.close();
  }
  private boolToNumber(value: boolean): number {
    return value ? 1 : 0;
  }
  newPart: any = {};
  openManualAddModal(content: any) {
    this.newPart = {}; // reset form
    this.showMakeDropdown = false;
    this.isMakeInvalid = false;
    this.modalService.open(content, {
      size: 'lg',
      backdrop: 'static',
      centered: true
    });
  }

  isDataInProgress = false;

  saveManualPart() {


    const row = {
      internalPartNo: this.newPart.internalPartNo,
      MPN: this.newPart.MPN,
      description: this.newPart.description,
      manufacturer: this.newPart.manufacturer,
      commodity: this.newPart.commodity,
      uom: this.newPart.uom,
      projectQty: this.newPart.projectQty
    };

    this.filteredData.push(row);



    const payload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0, // Get from selected project data
      sourcing_type: [...this.dataPreference], //  array



      data: [
        {
          part_header: {
            internalPartNo: this.newPart.internalPartNo,
            customerPartNumber: '',
            description: this.newPart.description,
            commodity: this.newPart.commodity,
            uom: this.newPart.uom,
            projectQty: this.newPart.projectQty,

            iSourcing: 'No',

            stockAvailability: this.criteria.stockAvailability ? 1 : 0,
            leadTime: this.criteria.leadTime ? 1 : 0,
            minimumPrice: this.criteria.minimumPrice ? 1 : 0,
            authorisedSuppliers: this.criteria.authorisedSuppliers ? 1 : 0,

            suppliers: this.criteria.selectedSuppliers || [],
            eau: 0
          },

          Parts: [
            {
              specification: this.newPart.MPN,
              manufacturer: this.newPart.manufacturer
            }
          ]
        }
      ]
    };




    this.masterService.finalCompareData(payload).subscribe({
      next: (res: any) => {
        console.log('Final Compare API Success', res);

        //  Show spinner
        this.isDataInProgress = true;

        //  Toast
        this.notify.info('Data In-Progress, please wait...');


        setTimeout(() => {
          this.getdata();

          //  Hide spinner AFTER data load
          this.isDataInProgress = false;

          this.notify.success('Data updated successfully');
        }, 5000);
      },

      error: (err: any) => {
        console.error('Final Compare API Error', err);
        this.isDataInProgress = false;
        this.notify.danger('Failed to process data');
      }
    });

  }

  openUploadModal(content: any) {
    console.log('Upload Data clicked');
    // ensure project/version are set
    this.selectedProjectId = Number(this.project_id);
    this.selectedVersionId = Number(this.version_id);

    this.modalRef = this.modalService.open(content, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'upload-file-modal'
    });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${reason}`;
    });
  }


  supplierOptions = [
    { id: 1, name: 'DigiKey' },
    { id: 2, name: 'element14 APAC' },
    { id: 3, name: 'Mouser' },
    { id: 4, name: 'Arrow Electronics' },
    { id: 5, name: 'FDH Electronics' },
    { id: 6, name: 'Heilind Electronics' },
    { id: 7, name: 'Onlinecomponents.com' },
    { id: 8, name: 'RS (Formerly Allied Electronics)' },
    { id: 9, name: 'TTI' },
    { id: 10, name: 'TME' },
    { id: 11, name: 'Future Electronics' },
  ];

  closeUploadModal() {
    this.clearAvdFiles();
    this.clearSourcingListFiles();
    this.headerErrorMessage = '';
    this.closeModal();
  }

  // This function is triggered when a sourcing list file is selected
  uploadSourcingListFiles(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      this.data = XLSX.utils.sheet_to_json(ws);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      // Remove "__rowNum__" property if it exists
      for (var j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == "__rowNum__") {
          this.dataProp.splice(j, 1);
        }
      }

      this.uploadedHeaders = Object.keys(this.data[0]).filter(h => h !== '__rowNum__');
      this.fieldMapping = {};
      this.uploadedHeaders.forEach(header => {
        this.fieldMapping[header] = null;
      });

      this.validateHeaders();
      this.sourceListData = [];
      let form: any = this.form;
      // Set the file name in the variable
      this.sourcingListFileName = target.files[0].name;
      form.get('sourcingListFileName').setValue(this.sourcingListFileName);

      // Use mapped fields (auto-mapping performed in validateHeaders)
      this.sourceListData = [];
      this.applyMappedData();

    };
  }

  validateHeaders() {
    this.headerErrorMessage = '';
    this.isHeaderMappingRequired = false;

    // Normalize by removing whitespace and non-alphanumeric chars to improve header matching
    const normalize = (str: string) => str?.toLowerCase().replace(/[^a-z0-9]/g, '').trim();

    // Define optional headers here
    const optionalHeaders = ['I Sourcing'];

    const expectedLabels = this.expectedFields
      .filter(f => !optionalHeaders.includes(f.label))
      .map(f => normalize(f.label));

    const uploadedLabels = this.uploadedHeaders.map(h => normalize(h));

    const missing = this.expectedFields
      .filter(f => !optionalHeaders.includes(f.label))
      .filter(f => !uploadedLabels.includes(normalize(f.label)))
      .map(f => f.label);

    if (missing.length > 0) {
      this.headerErrorMessage = 'Missing headers: ' + missing.join(', ');
      this.isHeaderMappingRequired = true;
    } else {
      this.isHeaderMappingRequired = false;
    }

    // Auto-map (including optional if present)
    this.reverseFieldMapping = {};
    this.tableHeaders.forEach(header => {
      const expectedField = this.expectedFields.find(f => f.key === header.key);
      if (expectedField) {
        const matchedHeader = this.uploadedHeaders.find(
          h => normalize(h) === normalize(expectedField.label)
        );
        this.reverseFieldMapping[header.key] = matchedHeader || null;
      }
    });
  }

  applyMappedData() {
    this.sourceListData = [];

    for (let row of this.data) {
      let rowO: any = row;
      let mappedRow: any = {};

      this.tableHeaders.forEach(header => {
        const uploadedHeader: any = this.reverseFieldMapping[header.key];

        if (uploadedHeader) {
          let val: any = rowO[uploadedHeader];

          if (header.key === 'projectQty') {
            mappedRow[header.key] = val !== undefined && val !== null && val !== ''
              ? Number(val)
              : undefined;
          } else {
            mappedRow[header.key] = val !== undefined && val !== null && val !== ''
              ? String(val).trim()
              : undefined;
          }
        } else {
          // dropdown not selected → undefined (show "Undefined" in table to match dashboard-engineer)
          mappedRow[header.key] = "Undefined";
        }
      });

      this.sourceListData.push(mappedRow);
    }

    if (this.avdData.length === 0) {
      this.finalDataList = this.sourceListData;
    }

    console.log('Final Mapped Data:', this.sourceListData);
  }

  clearSourcingListFiles() {
    this.sourcingListFileName = '';
    this.form.get('sourcingListFileName')?.setValue('');
    this.sourceListData = [];
    this.finalDataList = [];

    const uploadInput = document.querySelector<HTMLInputElement>('.file-input');
    if (uploadInput) {
      uploadInput.value = '';
    } else {
      console.warn('File input is not defined. Skipping clearing input value.');
    }
  }

  // Upload AVD
  uploadAvdFiles(event: any) {
    this.finalDataList = [];
    this.avdData = [];

    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);

    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      this.data = XLSX.utils.sheet_to_json(ws);
      this.dataProp = Object.getOwnPropertyNames(this.data[0]);

      for (let j = 0; j < this.dataProp.length; j++) {
        if (this.dataProp[j] == '__rowNum__') {
          this.dataProp.splice(j, 1);
        }
      }

      this.alternatePartFileName = target.files[0].name;
      let form: any = this.form;
      form.get('alternatePartFileName').setValue(this.alternatePartFileName);

      for (let i = 0; i < this.data.length; i++) {
        let obj = {
          internalPartNo: String(this.data[i]['Internal Part No.'] || '').trim(),
          manufacturer: String(this.data[i]['Manufacturer(Mfg)'] || '').trim(),
          specification: String((this.data[i]['Specification'] || '').toString()).trim().replace(/\s+/g, ''),
        };
        this.avdData.push(obj);
      }
    };
  }

  finalData() {
    this.isLoading = true;

    if (this.sourceListData.length === 0) {
      this.notify.info('Please upload sourcing list');
      this.clearAvdFiles();
      this.clearSourcingListFiles();
      this.closeModal();
      this.isLoading = false;
    } else {
      this.finalDataList = [];
      this.matchedCustomerData = [];
      this.fetchAllManufacturerMatches();

      if (this.avdData.length > 0) {
        for (const avdItem of this.avdData) {
          const matchingSourceItems = this.sourceListData.filter(
            (sourceItem) => String(sourceItem.internalPartNo).trim() === String(avdItem.internalPartNo).trim()
          );

          if (matchingSourceItems.length > 0) {
            for (const sourceItem of matchingSourceItems) {
              const qty = Number(sourceItem.projectQty) || 0;
              const combinedRow = {
                ...avdItem,
                customerPartNumber: sourceItem.customerPartNumber || '',
                description: sourceItem.description || '',
                commodity: sourceItem.commodity || '',
                uom: sourceItem.uom || '',
                projectQty: qty.toFixed(2),
                iSourcing: sourceItem.iSourcing || '',
              };
              this.finalDataList.push(combinedRow);
            }
          }
        }
      }

      if (this.avdData.length === 0 || !this.avdData) {
        this.notify.warning('Data processed without AVD file');
        this.finalDataList = [...this.sourceListData];
      } else {
        for (const sourceItem of this.sourceListData) {
          const matchingAvdItem = this.avdData.find(
            (avdItem) => String(avdItem.internalPartNo).trim() === String(sourceItem.internalPartNo).trim()
          );

          if (!matchingAvdItem) {
            const qty = Number(sourceItem.projectQty) || 0;
            const combinedRow = {
              ...sourceItem,
              customerPartNumber: sourceItem.customerPartNumber || '',
              description: sourceItem.description || '',
              commodity: sourceItem.commodity || '',
              uom: sourceItem.uom || '',
              projectQty: qty.toFixed(2),
              iSourcing: sourceItem.iSourcing || '',
            };
            this.finalDataList.push(combinedRow);
          }
        }
      }

      this.processFinalData();
      console.log('Before Filtered Final Data List:', this.finalDataList);
      this.isLoading = false;
    }
  }

  processFinalData() {
    const uniqueDataMap = new Map<string, any>();

    for (const data of this.finalDataList) {
      const normalizeString = (value: string | number): string => {
        if (typeof value !== 'string') return String(value).trim();
        return value.trim();
      };

      const key = `${normalizeString(data.internalPartNo)}::${normalizeString(data.manufacturer)}::${normalizeString(data.specification)}::${Number(data.projectQty)}`;

      if (!uniqueDataMap.has(key)) {
        uniqueDataMap.set(key, data);
      }
    }

    this.finalDataList = Array.from(uniqueDataMap.values());

    setTimeout(() => {
      this.sourceListData = [];
      this.avdData = [];
      this.closeModal();
    }, 100);

    this.finalCompareDataList = this.finalDataList;

    // Enable upload button only when we have final data and selected project/version
    this.isUploadEnabled = this.finalDataList && this.finalDataList.length > 0;

    // Ensure selected project/version are set (opened from modal usually sets them; this is a safeguard)
    if (!this.selectedProjectId) {
      this.selectedProjectId = Number(this.project_id) || null;
    }
    if (!this.selectedVersionId) {
      this.selectedVersionId = Number(this.version_id) || null;
    }
  }

  // Toggle search visibility for a given column
  toggleSearch(index: number) {
    this.showSearch = true;
    this.showSearchRow[index] = !this.showSearchRow[index];
  }

  // Filter finalDataList using searchValues (based on finalCompareDataList as baseline)
  filterData() {
    const hasSearch = this.searchValues.some(val => val && val.trim() !== '');

    if (hasSearch) {
      const filtered = this.finalCompareDataList.filter(item =>
        this.tableHeaders.every((col, i) => {
          const searchValue = this.searchValues[i]?.toLowerCase().trim();
          if (!searchValue) return true;
          const itemValue = (item[col.key] || '').toString().toLowerCase();
          return itemValue.includes(searchValue);
        })
      );

      if (filtered.length > 0) {
        this.finalDataList = filtered;
      } else {
        // No match -> keep empty list
        this.finalDataList = [];
      }
    } else {
      this.finalDataList = [...this.finalCompareDataList];
    }
  }

  // Export a sample preview Excel for user's reference
  // exportPreviewSample() {
  //   const sample = [
  //     {
  //       'Customer Part No.': '461500500155',
  //       'Internal Part No.': '461500500155',
  //       'Description': 'Sample description',
  //       'Specification': 'SPEC-123',
  //       'Commodity': 'Connectors',
  //       'Manufacturer(Mfg)': 'AMPHENOL AEROSPACE',
  //       'UOM': 'EA',
  //       'Project qty': 12.0,
  //       'I Sourcing': 'Yes'
  //     }
  //   ];

  //   this.exportService.exportToExcel(sample, 'Preview_Sample.xlsx', 'PreviewSample');
  // }

  onClickSmartSync() {
    this.router.navigate(['/smart-sync'])
  }

  uploadFinalData() {
    if (!this.selectedProjectId || !this.selectedVersionId) {
      this.notify.info('Please select project and version before uploading.');
      return;
    }

    this.isUploading = true; // Show loader

    console.log(this.finalDataList);
    sessionStorage.setItem('project_id', this.selectedProjectId);
    sessionStorage.setItem('version_id', String(this.selectedVersionId));

    const rawSuppliers = this.criteria?.selectedSuppliers || [];
    const normalizedSuppliers: string[] = (Array.isArray(rawSuppliers) ? rawSuppliers : [rawSuppliers])
      .map((s: any) => {
        if (!s) return '';
        if (typeof s === 'string') return s.trim();
        if (typeof s === 'object') return (s.name || s.supplierName || s.label || '').trim();
        return String(s).trim();
      })
      .filter((s: string) => s.length > 0);

    const hasSelectedSuppliers = normalizedSuppliers.length > 0;
    const isAuthSuppliers = Boolean(this.criteria?.authorisedSuppliers || hasSelectedSuppliers);

    const criteriaStockAvailability = this.boolToNumber(this.criteria?.stockAvailability);
    const criteriaLeadTime = this.boolToNumber(this.criteria?.leadTime);
    const criteriaMinPrice = this.boolToNumber(this.criteria?.minimumPrice);
    const criteriaAuthSuppliers = isAuthSuppliers ? 1 : 0;

    const hasAnyCriteriaConfigured = Boolean(
      this.isCriteriaSelected ||
      this.criteria?.stockAvailability ||
      this.criteria?.leadTime ||
      this.criteria?.minimumPrice ||
      this.criteria?.authorisedSuppliers ||
      hasSelectedSuppliers
    );

    const groupedData = new Map();
    this.finalDataList.forEach(part => {
      const internalPartNo = String(part.internalPartNo) || "";
      if (!groupedData.has(internalPartNo)) {
        const stockAvailability = hasAnyCriteriaConfigured
          ? criteriaStockAvailability
          : (Number(part.stockAvailability) >= 0 ? Number(part.stockAvailability) : 0);

        const leadTime = hasAnyCriteriaConfigured
          ? criteriaLeadTime
          : (Number(part.leadTime) ? Number(part.leadTime) : 0);

        const minimumPrice = hasAnyCriteriaConfigured
          ? criteriaMinPrice
          : (Number(part.minimumPrice) >= 0 ? Number(part.minimumPrice) : 0);

        const authorisedSuppliers = hasAnyCriteriaConfigured
          ? criteriaAuthSuppliers
          : (Number(part.authorisedSuppliers) >= 0 ? Number(part.authorisedSuppliers) : 0);

        let rowSuppliers: string[] = [];
        if (hasSelectedSuppliers) {
          rowSuppliers = [...normalizedSuppliers];
        } else if (Array.isArray(part.suppliers) && part.suppliers.length > 0) {
          rowSuppliers = part.suppliers
            .map((s: any) => typeof s === 'string' ? s.trim() : (s?.supplierName || s?.name || String(s)).trim())
            .filter(Boolean);
        }

        groupedData.set(internalPartNo, {
          part_header: {
            internalPartNo: internalPartNo,
            customerPartNumber: String(part.customerPartNumber) || "",
            description: (String(part.description).replace(/"/g, '').replace(/\\/g, '/')) || "",
            commodity: (String(part.commodity).replace(/"/g, '').replace(/\\/g, '/')) || "",
            uom: String(part.uom) || "",
            projectQty: Number(part.projectQty) > 0 ? Number(part.projectQty) : 0,
            iSourcing: part.iSourcing == "Yes" ? "Yes" : "No",
            stockAvailability: stockAvailability,
            leadTime: leadTime,
            minimumPrice: minimumPrice,
            authorisedSuppliers: authorisedSuppliers,
            suppliers: rowSuppliers,
            eau: Number(part.eau) >= 0 ? Number(part.eau) : 0,
          },
          Parts: []
        });
      }

      const originalManufacturer = part.manufacturer;
      const selectedManufacturer = this.manufacturerOverrideMap[originalManufacturer] || originalManufacturer;

      groupedData.get(internalPartNo).Parts.push({
        specification: (String(part.specification).replace(/"/g, '').replace(/\\/g, '/')) || "",
        manufacturer: selectedManufacturer
      });
    });

    const procVersionId = this.fromProcurement
      ? Number(this.procurement_version_id || 0)
      : Number(this.customerInfoData?.procurement_version_id ?? sessionStorage.getItem('procurement_version_id') ?? 0);

    const sourcingType = (this.dataPreference && this.dataPreference.length > 0)
      ? this.dataPreference
      : ['vendor'];

    const finalPayload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: procVersionId,
      sourcing_type: sourcingType,
      data: Array.from(groupedData.values())
    };
    this.isDataInProgress = true;


    this.notify.info('Data In-Progress, please wait...');

    console.log('finalPayload', finalPayload);

    this.masterService.finalCompareData(finalPayload).subscribe({
      next: (res) => {
        this.isUploading = false;
        this.isDataInProgress = false;
        if (res) {
          this.notify.success('Data uploaded successfully...');
          this.form.reset();
          this.resetFinalData();
          // refresh data
          this.getdata();
        } else {
          this.notify.danger('Unexpected response received. Please try again.');
        }
      },
      error: (err) => {
        this.isUploading = false;
        this.isDataInProgress = false;
        console.error('An error occurred:', err);
        let errorMessage = 'An error occurred while uploading data. Please try again.';
        if (err?.message) {
          errorMessage = `Error: ${err.message}`;
        } else if (err?.error?.message) {
          errorMessage = `Error: ${err.error.message}`;
        }
        this.notify.danger(errorMessage);
      }
    });
  }

  clearAvdFiles() {
    this.alternatePartFileName = '';
    this.form.get('alternatePartFileName')?.setValue('');
    this.avdData = [];

    const uploadAvdInput = document.querySelector<HTMLInputElement>('.file-input');
    if (uploadAvdInput) {
      uploadAvdInput.value = '';
    }
  }

  openHeaderMappingModal(content: any) {
    this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
  }

  handleFileUpload(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    if (file.name.toLowerCase().endsWith('.pdf')) {
      this.notify.info('PDF uploads are not supported in Project View. Please upload an XLSX file.');
      return;
    }

    // Otherwise handle as spreadsheet
    this.uploadAvdFiles(event);
  }
  isManualAddValid(): boolean {
    return (
      this.newPart.internalPartNo &&
      this.newPart.MPN &&
      this.newPart.description &&
      this.newPart.manufacturer &&
      this.newPart.commodity &&
      this.newPart.uom &&
      this.newPart.projectQty > 0 &&
      this.dataPreference &&
      this.dataPreference.length > 0
    );
  }


  fetchAllManufacturerMatches() {
    this.sourceListData.forEach((item: any, idx: number) => {
      const payloadData = { name: String(item.manufacturer).trim() };
      this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
        if (result) {
          this.buttonColorMap[item.manufacturer] = result.exact_match === 1 ? 'btn-mfgs' : 'btn-mfg';
          this.allManufacturerDetailsMap[item.customerPartNumber || idx] = result.matches;
          this.showDropdownMap[item.customerPartNumber || idx] = false;
        } else {
          console.error('Error: Unable to retrieve manufacturer data');
          this.buttonColorMap[item.manufacturer] = 'btn-light';
        }
      });
    });
  }

  checkManufacturerMatch(item: any, index: number) {
    const uniqueKey = index;
    const payloadData = { name: String(item.manufacturer).trim() };

    this.masterService.manufacturer_Name_search(payloadData).subscribe((result: any) => {
      if (result) {
        const matches = result.matches || [];
        if (!matches.includes(item.manufacturer)) {
          matches.unshift(item.manufacturer);
        }
        this.allManufacturerDetailsMap[uniqueKey] = matches;
        if (!this.selectedManufacturerMap[uniqueKey]) {
          this.selectedManufacturerMap[uniqueKey] = item.manufacturer;
        }
      } else {
        console.error('Error: Unable to retrieve manufacturer data');
      }
    });
  }

  toggleDropdownVisibility(item: any, index: number) {
    const uniqueKey = index;
    this.isDropdownVisible[uniqueKey] = !this.isDropdownVisible[uniqueKey];

    // When opening the dropdown, set a visible border color based on match status
    if (this.isDropdownVisible[uniqueKey]) {
      const colorClass = this.buttonColorMap[item.manufacturer];
      if (colorClass === 'btn-mfgs') {
        this.buttonBorderStyle[uniqueKey] = '2px solid #45d640'; // green
      } else if (colorClass === 'btn-mfg') {
        this.buttonBorderStyle[uniqueKey] = '2px solid #d64059'; // red
      } else {
        this.buttonBorderStyle[uniqueKey] = '1px solid #ccc'; // neutral
      }
    }

    if (this.isDropdownVisible[uniqueKey] && !this.allManufacturerDetailsMap[uniqueKey]) {
      this.checkManufacturerMatch(item, index);
      return;
    }

    if (this.isDropdownVisible[uniqueKey] && this.allManufacturerDetailsMap[uniqueKey]?.length > 0) {
      if (!this.selectedManufacturerMap[uniqueKey]) {
        const defaultValue = this.allManufacturerDetailsMap[uniqueKey][0];
        this.selectedManufacturerMap[uniqueKey] = defaultValue;

        const fakeEvent = { target: { value: defaultValue } };
        this.onManufacturerChange(fakeEvent, item, index);
      }
    }
  }

  onManufacturerChange(event: any, item: any, index: number) {
    const selectedManufacturer = event.target.value;
    const originalManufacturer = item.manufacturer;

    this.manufacturerOverrideMap[originalManufacturer] = selectedManufacturer;

    // When user selects an override, mark it as confirmed (green) and set visible border
    this.buttonColorMap[originalManufacturer] = 'btn-mfgs';
    this.buttonBorderStyle[index] = '2px solid #45d640';

    this.isDropdownVisible[index] = false;

    console.log(`UI override: '${originalManufacturer}' → '${selectedManufacturer}'`);
  }

  saveRowEdit() {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }
    if (!this.editingRow) return;
    const confirmSave = window.confirm('Are you sure you want to save the PartDetails?');
    if (!confirmSave) {
      return;
    }

    console.log('editRowIndex => ', this.filteredData[this.editRowIndex], 'editableRow =>', this.editableRow)

    this.editingRow.specification = this.editableRow.specification;
    this.editingRow.manufacturer = this.editableRow.manufacturer;
    this.editingRow.commodity = this.editableRow.commodity;
    this.editingRow.uom = this.editableRow.uom;
    this.editingRow.projectQty = this.editableRow.projectQty;


    const payload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0, // Get from selected project data
      sourcing_type: this.dataPreference && this.dataPreference.length > 0 ? this.dataPreference : ['vendor'],

      data: [
        {
          part_header: {
            internalPartNo: this.editingRow.internalPartNo,
            customerPartNumber: this.editingRow.customerPartNumber || '',
            description: this.editingRow.description || '',
            commodity: this.editableRow.commodity,
            uom: this.editableRow.uom,
            projectQty: this.editableRow.projectQty,
            iSourcing: this.editingRow.iSourcing || 'No',
            stockAvailability: this.boolToNumber(this.criteria.stockAvailability),
            leadTime: this.boolToNumber(this.criteria.leadTime),
            minimumPrice: this.boolToNumber(this.criteria.minimumPrice),
            authorisedSuppliers: (this.criteria.authorisedSuppliers || (this.criteria.selectedSuppliers && this.criteria.selectedSuppliers.length > 0)) ? 1 : 0,
            suppliers: (this.criteria.selectedSuppliers && this.criteria.selectedSuppliers.length > 0)
              ? this.criteria.selectedSuppliers.map((s: any) => typeof s === 'string' ? s.trim() : (s?.name || s?.supplierName || String(s)).trim()).filter(Boolean)
              : [],
            eau: this.editingRow.eau || 0
          },

          Parts: [
            {
              specification: this.editableRow.specification,
              manufacturer: this.editableRow.manufacturer
            }
          ]
        }
      ]
    };


    console.log(' FINAL MERGED PAYLOAD =>', payload);


    this.masterService.finalCompareData(payload).subscribe({
      next: () => {
        this.notify.success('Data saved successfully');

        this.editingRow = null;

      },
      error: (err) => {
        console.error(err);
        this.notify.danger('Save failed');
      }
    });
  }
  deleteRow(row: any) {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }
    const confirmDelete = window.confirm(
      `Are you sure you want to delete Internal Part No: ${row.internalPartNo}?`
    );

    if (!confirmDelete) {
      return;
    }

    const engineerId = Number(this.engineer_id ?? sessionStorage.getItem('engineer_id') ?? 0);
    const managerId = Number(this.manager_id ?? sessionStorage.getItem('manager_id') ?? 0);
    const procVersionId = this.fromProcurement
      ? Number(this.procurement_version_id || 0)
      : Number(this.customerInfoData?.procurement_version_id ?? 0);

    const payload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: procVersionId,
      internalPartNo: String(row.internalPartNo),
      engineer_id: engineerId,
      manager_id: managerId,
      collection_id: "1"
    };

    console.log('Delete payload =>', payload);

    this.masterService.Delete_part(payload).subscribe({
      next: () => {
        this.notify.success('Part deleted successfully');

        // UI update without refresh
        this.filteredData = this.filteredData.filter(
          (item: any) => item.internalPartNo !== row.internalPartNo
        );

        this.finalConvertedData = this.finalConvertedData.filter(
          (item: any) => item.internalPartNo !== row.internalPartNo
        );

        this.editingRow = null;
      },
      error: (err) => {
        console.error(err);
        this.notify.danger('Failed to delete part');
      }
    });
  }



  onManufacturerBlur() {

    setTimeout(() => {
      this.manufacturerSuggestions = [];

      const value = this.editableRow.manufacturer?.toLowerCase() || '';

      // validate after blur
      this.isManufacturerInvalid =
        value.length > 0 &&
        !this.manufacturerSuggestionsCache
          .map(m => m.toLowerCase())
          .includes(value);

    }, 200);
  }
  openAddPartModal(content: any) {
    this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: 'add-part-modal'
    });
  }

  uploadData() {
    console.log('Upload Data clicked');
    // file upload popup / navigate / logic
  }

  addManually() {
    console.log('Add Manually clicked');
    // new empty row add logic
  }

  cancelRowEdit() {
    this.editingRow = null;
    this.editableRow = {};
  }



  calculateProjectCost() {
    this.projectCost = this.filteredData.reduce((total, row) => {
      const value = Number(row.total_value_inr) || 0;
      return total + value;
    }, 0);
    this.projectCost = Math.round(this.projectCost);
    console.log("Project Cost (Grand Total):", this.projectCost);
  }

  private calculateComparisonSummary(projects: any[]): {
    uniqueParts: number;
    sourcedParts: number;
    totalCost: number;
  } {
    const uniqueParts = new Set<string>();
    const sourcedPartsSet = new Set<string>();
    let sourcedPartsCount = 0;
    let totalCost = 0;

    const isSourcedPart = (part: any): boolean => {
      const supplier = String(part?.supplier ?? '').trim().toLowerCase();
      return (
        !!supplier &&
        supplier !== 'n/a' &&
        supplier !== 'na' &&
        supplier !== '-' &&
        supplier !== 'null' &&
        supplier !== 'undefined' &&
        supplier !== 'none'
      );
    };

    (projects || []).forEach((project: any) => {
      (project?.parts || []).forEach((part: any) => {
        const internalPartNo = String(part?.internalPartNo ?? '').trim();
        if (internalPartNo) {
          uniqueParts.add(internalPartNo);
        }

        if (isSourcedPart(part)) {
          if (internalPartNo) {
            sourcedPartsSet.add(internalPartNo);
          } else {
            sourcedPartsCount++;
          }

          const qty = Math.max(
            Number(part?.projectQty) || 0,
            Number(part?.Closest_Quantity) || 0
          );
          const landingCost = Number(part?.landing_cost) || 0;
          const rowTotal = Number(part?.total_value_inr);
          const partCost = Number.isFinite(rowTotal) && rowTotal > 0 ? rowTotal : (landingCost * qty);
          totalCost += partCost;
        }
      });
    });

    const finalSourced = sourcedPartsSet.size > 0 ? sourcedPartsSet.size : sourcedPartsCount;
    const finalUnique = uniqueParts.size > 0 ? uniqueParts.size : (projects?.[0]?.parts?.length || 0);

    return {
      uniqueParts: finalUnique,
      sourcedParts: finalSourced,
      totalCost: Math.round(totalCost)
    };
  }

  private applyComparisonSummary(projects: any[], target: 'compare' | 'with'): void {
    const summary = this.calculateComparisonSummary(projects);

    if (target === 'compare') {
      this.uniquePartsSize = summary.uniqueParts;
      this.partsExceptNACompare = summary.sourcedParts;
      this.totalSuminCompare = summary.totalCost;
      return;
    }

    this.uniquePartsWith = summary.uniqueParts;
    this.partsExceptNAWith = summary.sourcedParts;
    this.totalSuminwith = summary.totalCost;
  }

  fetchDashboardStats() {
    this.loadDashboardStatsFromCustomerInfo();
  }

  loadDashboardStatsFromCustomerInfo() {
    if (this.customerInfoData) {
      this.uniquePartsCount = this.customerInfoData.no_of_parts || 0;
      this.partsExceptNA = this.customerInfoData.closed_parts || 0;
      this.projectCost = Math.round(this.customerInfoData.total_sourced_value || 0);
      this.partsNA = this.uniquePartsCount - this.partsExceptNA;
    }
  }

  showAllPartsCount() {
    this.savedFilter = 'all';
    sessionStorage.setItem('projectViewFilter', 'all');

    this.applySavedFilter('all');

    console.log(
      "Filter changed to ALL | Count:",
      this.finalConvertedData.length
    );
  }

  showSourcedParts() {
    this.savedFilter = 'sourced';
    sessionStorage.setItem('projectViewFilter', 'sourced');
    this.applySupplySenseFilters();
    console.log(" SOURCED PARTS LIST (", this.filteredData.length, ") ↓↓↓");
  }


  showUnsourcedParts() {
    this.savedFilter = 'unsourced';
    sessionStorage.setItem('projectViewFilter', 'unsourced');
    this.applySupplySenseFilters();

    console.log(
      "Filter changed to UNSOURCED | Count:",
      this.filteredData.length
    );
  }

  get completion_percentage(): number {
    if (this.finalConvertedData && this.finalConvertedData.length > 0) {
      const totalRows = this.finalConvertedData.length;
      const validSupplierCount = this.finalConvertedData.filter(
        (item: any) => item.supplier && item.supplier !== 'N/A' && item.supplier !== 'NA'
      ).length;
      return Math.round((validSupplierCount / totalRows) * 100);
    }
    const progVal = this.customerInfoData?.completion_percentage ?? this.customerInfoData?.progress ?? this.progressPercentage ?? 0;
    return typeof progVal === 'number' ? progVal : parseFloat(String(progVal).replace('%', '')) || 0;
  }

  calculateProgress(data: any[]): string {
    const totalRows = data.length;
    if (totalRows === 0) return '0';

    const validSupplierCount = data.filter(
      item => item.supplier && item.supplier !== 'N/A'
    ).length;

    const progress = (validSupplierCount / totalRows) * 100;
    return progress.toFixed(2);
  }

  getPriceComparisonArrow(part: any): string {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    if (!matched || matched.Price == null || part.Price == null) {
      return '';
    }

    if (part.Price > matched.Price) {
      return 'up';
    } else if (part.Price < matched.Price) {
      return 'down';
    } else {
      return '';
    }
  }

  getPriceDifference(part: any): number | null {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    if (!matched || matched.Price == null || part.Price == null) {
      return null;
    }

    return part.Price - matched.Price;
  }



  getStockComparisonArrow(part: any): string {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    const partStock = part?.Inventorylevel != null ? Number(part.Inventorylevel) : null;
    const matchedStock = matched?.Inventorylevel != null ? Number(matched.Inventorylevel) : null;

    if (!matched || matchedStock == null || partStock == null || isNaN(partStock) || isNaN(matchedStock)) {
      return '';
    }

    if (partStock > matchedStock) {
      return 'up';
    } else if (partStock < matchedStock) {
      return 'down';
    } else {
      return '';
    }
  }
  getStockDifference(part: any): number | null {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    const partStock = part?.Inventorylevel != null ? Number(part.Inventorylevel) : null;
    const matchedStock = matched?.Inventorylevel != null ? Number(matched.Inventorylevel) : null;

    if (!matched || matchedStock == null || partStock == null || isNaN(partStock) || isNaN(matchedStock)) {
      return null;
    }

    return partStock - matchedStock;
  }

  getLandingCostColor(part: any): string {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    if (!matched || matched.landing_cost == null || part.landing_cost == null) {
      return '';
    }

    const withCost = parseFloat(part.landing_cost);
    const compareCost = parseFloat(matched.landing_cost);

    if (isNaN(withCost) || isNaN(compareCost)) {
      return '';
    }

    if (withCost > compareCost) {
      return 'red';
    } else if (withCost < compareCost) {
      return 'green';
    }
    return '';
  }

  getLandingCostArrow(part: any): string {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    if (!matched || matched.landing_cost == null || part.landing_cost == null) {
      return '';
    }

    const withCost = parseFloat(part.landing_cost);
    const compareCost = parseFloat(matched.landing_cost);

    if (isNaN(withCost) || isNaN(compareCost)) return '';

    if (withCost > compareCost) return 'up';
    if (withCost < compareCost) return 'down';
    return '';
  }

  getLandingCostDifference(part: any): number | null {
    const matched = this.filteredFirstTableData
      .map(item => item.parts)
      .reduce((acc, val) => acc.concat(val), [])
      .find((row: any) => row.internalPartNo === part.internalPartNo);

    if (!matched || matched.landing_cost == null || part.landing_cost == null) {
      return null;
    }

    const withCost = parseFloat(part.landing_cost);
    const compareCost = parseFloat(matched.landing_cost);

    if (isNaN(withCost) || isNaN(compareCost)) return null;

    return +(withCost - compareCost).toFixed(2);
  }

  tabs = [
    { label: 'Tab 1', content: 'Content for Tab 1' },
    { label: 'Tab 2', content: 'Content for Tab 2' },
    { label: 'Tab 3', content: 'Content for Tab 3' },
  ];
  currentFilter: 'all' | 'sourced' | 'unsourced' = 'all'; // default

  onPartInfo(row: any) {

    sessionStorage.setItem('internalPartNo', String(row?.internalPartNo));
    sessionStorage.setItem('mpnMatch', String(row?.MPN));
    sessionStorage.setItem('project_id', String(this.project_id));
    sessionStorage.setItem('version_id', String(this.version_id));
    sessionStorage.setItem('projectQty', String(row?.projectQty));
    sessionStorage.setItem('projectSupplierInfo', JSON.stringify(row));
    sessionStorage.setItem('projectViewFilter', this.savedFilter);
    console.log("Saved Filter Going to Part Info:", this.savedFilter);
    console.log("supplystatetabtype sent to Part Info:", this.savedFilter);

    let state: any = history.state
    //  Important: send saved filter
    this.router.navigate(['/part-info'], {
      state: {

        startIndex: state?.startIndex ?? 0,
        endIndex: state?.endIndex ?? 10,
        rowsPerPage: state ? state.rowsPerPage : 10,
        currentPage: !!state ? state?.currentPage : 1,

        supplystatetabtype: this.savedFilter,
        selectedTabIndex: this.selectedTabIndex,

        customerInfo: structuredClone(this.customerInfoData),
        row,
        savedFilter: this.savedFilter     //  ADD THIS
      }

    });
  }

  internalPartNo(internalPartNo: any): string {
    throw new Error('Method not implemented.');
  }


  // fetchProjectViewData() {
  //   this.isLoading = true;  // Start loading

  //   const params = {
  //     "project_id": Number(this.customerInfoData.project_id),
  //     "version_id": Number(this.customerInfoData.version_id),
  //   };
  //   console.log('Fetching project view data with params:', params);
  //   this.masterService.get_Projectview(params).subscribe(
  //     (data) => {
  //       this.isLoading = false;  // Stop loading on success
  //       console.log('Full API Response:', data);
  //       if (data && data.results && data.results.length > 0) {
  //         this.projectViewData = data.results.filter((x) => x.projectName === this.customerInfoData.projectName);

  //         this.filteredFirstTableData = this.projectViewData;
  //         this.filteredSecondTableData = this.projectViewData;

  //         console.log('Populated Project View Data:', this.projectViewData);
  //         if (this.highlightedIPN) {
  //           setTimeout(() => {
  //             this.scrollToHighlightedRow();
  //           });
  //         }
  //       } else {
  //         this.errorMessage = 'No data available';
  //         console.error('No results returned from the API');
  //       }
  //     },
  //     (error) => {
  //       this.isLoading = false;  // Stop loading on error
  //       this.errorMessage = 'Failed to load project view data';
  //       console.error(error);
  //     });
  // }
  fetchProjectViewData(procurementVersionId: number = 0, versionId: number | null = null) {
    this.isLoading = true;

    const params: any = {
      project_id: Number(this.customerInfoData.project_id),
      procurement_version_id: procurementVersionId
    };

    // Include version_id if provided
    if (versionId !== null && versionId !== undefined) {
      params.version_id = versionId;
    }

    console.log('Fetching project view data with params:', params);

    this.masterService.get_Projectview(params).subscribe(
      (data: any) => {
        this.isLoading = false;

        if (data && data.results && data.results.length > 0) {
          this.projectViewData = data.results.filter(
            (x: any) => x.projectName === this.customerInfoData.projectName
          );
          const currencyConversionRates: { [key: string]: number } = {
            INR: 1,
            USD: 86,
            EUR: 90
          };

          this.projectViewData.forEach((project: any) => {
            project.parts = project.parts.map((row: any) => {

              const landingCostInINR = row.landing_cost || 0;
              const conversionRate = currencyConversionRates[row.Currency] || 1;
              const estLandingCost = (row.Price || 0) * conversionRate * 1.28;

              const priceColor = estLandingCost > landingCostInINR ? 'green' : 'red';

              return {
                ...row,
                priceColor
              };
            });
          });
          this.filteredFirstTableData = this.projectViewData;
          this.filteredSecondTableData = this.projectViewData;

          if (this.highlightedIPN) {
            setTimeout(() => this.scrollToHighlightedRow());
          }
        } else {
          this.errorMessage = 'No data available';
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load project view data';
        console.error(error);
      }
    );
  }

  onIpnClick(ipn: string) {
    this.highlightedIpn = ipn;
    setTimeout(() => {
      const el = document.querySelector('.compare-tables-grid .compare-table-wrap:first-child .highlight-row');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 50);
  }

  /**
   * Initialize available versions by calling the dropdown API
   */
  initializeAvailableVersions(): void {
    // If navigated from procurement tab, default compare/with to Procurement
    if (this.fromProcurement) {
      this.compareStageType = 'Procurement';
      this.withStageType = 'Procurement';
    }

    // Fetch dropdown versions for both Compare and With panels
    this.fetchComparisonDropdown('compare', this.compareStageType);
    this.fetchComparisonDropdown('with', this.withStageType);
  }

  /**
   * Helper to match exactly one project object matching stage, version_id/procurement_version_id
   */
  private getMatchedVersionProject(
    results: any[],
    stageType: string,
    versionId: number,
    targetProjectName: string
  ): any {
    if (!results || results.length === 0) return null;

    const vId = Number(versionId);
    const isCosting = stageType === 'Costing';

    // 1. Try matching by version and stage strictly
    let matched = results.filter((x: any) => {
      if (isCosting) {
        const itemVId = Number(x.version_id);
        const itemProcId = Number(x.procurement_version_id || 0);
        return itemVId === vId && itemProcId === 0;
      } else {
        const itemProcId = Number(x.procurement_version_id);
        return itemProcId === vId;
      }
    });

    // 2. If no strict match and is Costing, match by version_id alone
    if (matched.length === 0 && isCosting) {
      matched = results.filter((x: any) => Number(x.version_id) === vId);
    }

    // 3. If multiple matched, filter by targetProjectName
    if (matched.length > 1 && targetProjectName) {
      const nameMatched = matched.filter(
        (x: any) => String(x.projectName || '').trim().toLowerCase() === targetProjectName
      );
      if (nameMatched.length > 0) {
        matched = nameMatched;
      }
    }

    // 4. Fallback if still not matched: filter results by targetProjectName
    if (matched.length === 0 && targetProjectName) {
      matched = results.filter(
        (x: any) => String(x.projectName || '').trim().toLowerCase() === targetProjectName
      );
    }

    // 5. Final fallback to first result
    return matched.length > 0 ? matched[0] : results[0];
  }

  /**
   * Call the comparison dropdown API to get available versions for a panel
   */
  fetchComparisonDropdown(panel: 'compare' | 'with', currentStage: string): void {
    const projectId = Number(this.customerInfoData?.project_id || this.project_id);
    const payload = {
      project_id: projectId,
      currentstage: currentStage
    };

    console.log(`🔄 Fetching ${panel} dropdown versions with payload:`, payload);

    this.masterService.get_projects_comparison_dropdown(payload).subscribe(
      (response: any) => {
        if (response && response.status === 'success' && response.data && response.data.length > 0) {
          if (currentStage === 'Costing') {
            const versions = [...new Set(response.data
              .map((item: any) => Number(item.version_id))
              .filter((v: any) => v !== null && v !== undefined && !isNaN(v)))] as number[];

            this.availableVersions = versions;

            if (panel === 'compare') {
              if (versions.length > 0 && !versions.includes(Number(this.compareVersionId))) {
                this.compareVersionId = versions[0];
              }
              console.log('✅ Compare costing versions from API:', this.availableVersions);
              this.fetchCompareTableData();
            } else {
              if (versions.length > 0 && !versions.includes(Number(this.withVersionId))) {
                this.withVersionId = versions.length > 1 ? versions[1] : versions[0];
              }
              console.log('✅ With costing versions from API:', this.availableVersions);
              this.fetchWithTableData();
            }
          } else {
            // Procurement
            const versions = [...new Set(response.data
              .map((item: any) => Number(item.procurement_version_id))
              .filter((v: any) => v !== null && v !== undefined && !isNaN(v) && v !== 0))] as number[];

            this.availableProcurementVersions = versions;

            if (panel === 'compare') {
              if (versions.length > 0 && !versions.includes(Number(this.compareVersionId))) {
                this.compareVersionId = versions[0];
              }
              console.log('✅ Compare procurement versions from API:', this.availableProcurementVersions);
              this.fetchCompareTableData();
            } else {
              if (versions.length > 0 && !versions.includes(Number(this.withVersionId))) {
                this.withVersionId = versions.length > 1 ? versions[1] : versions[0];
              }
              console.log('✅ With procurement versions from API:', this.availableProcurementVersions);
              this.fetchWithTableData();
            }
          }
        } else {
          console.warn(`⚠️ No ${panel} dropdown data for stage:`, currentStage);
          if (panel === 'compare') {
            if (currentStage === 'Costing') {
              this.availableVersions = [];
            } else {
              this.availableProcurementVersions = [];
            }
            this.filteredFirstTableData = [];
            this.applyComparisonSummary([], 'compare');
          } else {
            if (currentStage === 'Costing') {
              this.availableVersions = [];
            } else {
              this.availableProcurementVersions = [];
            }
            this.filteredSecondTableData = [];
            this.applyComparisonSummary([], 'with');
          }
        }
      },
      (error) => {
        console.error(`❌ Error fetching ${panel} dropdown:`, error);
      }
    );
  }

  /**
   * Fetch data for Compare table
   */
  fetchCompareTableData(): void {
    const procurementVersionId = this.compareStageType === 'Costing' ? 0 : Number(this.compareVersionId);
    const versionId = this.compareStageType === 'Costing' ? Number(this.compareVersionId) : null;
    const projectId = Number(this.customerInfoData?.project_id || this.project_id);

    this.isLoading = true;
    const params: any = {
      project_id: projectId,
      procurement_version_id: procurementVersionId
    };

    // Include version_id only for Costing stage
    if (versionId !== null && versionId !== undefined) {
      params.version_id = versionId;
    }

    console.log('🔄 Fetching Compare table data with params:', params);

    this.masterService.get_Projectview(params).subscribe(
      (data: any) => {
        this.isLoading = false;

        if (data && data.results && data.results.length > 0) {
          const targetProjectName = String(this.customerInfoData?.projectName || this.projectName || '').trim().toLowerCase();
          const matchedProject = this.getMatchedVersionProject(
            data.results,
            this.compareStageType,
            Number(this.compareVersionId),
            targetProjectName
          );

          if (matchedProject) {
            const projectClone = JSON.parse(JSON.stringify(matchedProject));
            const currencyConversionRates: { [key: string]: number } = {
              INR: 1,
              USD: 86,
              EUR: 90
            };

            const isSourcedPart = (part: any): boolean => {
              const supplier = String(part?.supplier ?? '').trim().toLowerCase();
              return (
                !!supplier &&
                supplier !== 'n/a' &&
                supplier !== 'na' &&
                supplier !== '-' &&
                supplier !== 'null' &&
                supplier !== 'undefined' &&
                supplier !== 'none'
              );
            };

            projectClone.parts = (projectClone.parts || []).map((row: any) => {
              const landingCostInINR = Number(row.landing_cost) || 0;
              const conversionRate = currencyConversionRates[row.Currency] || 1;
              const estLandingCost = (Number(row.Price) || 0) * conversionRate * 1.28;
              const priceColor = estLandingCost > landingCostInINR ? 'green' : 'red';
              const qty = Math.max(Number(row.projectQty) || 0, Number(row.Closest_Quantity) || 0);
              const totalValueINR = isSourcedPart(row) ? (landingCostInINR * qty) : 0;

              return { ...row, priceColor, total_value_inr: totalValueINR };
            });

            this.filteredFirstTableData = [projectClone];
            this.applyComparisonSummary(this.filteredFirstTableData, 'compare');
            console.log('✅ Compare table data updated for version:', this.compareVersionId);
          } else {
            this.filteredFirstTableData = [];
            this.applyComparisonSummary([], 'compare');
          }
        } else {
          this.errorMessage = 'No data available for Compare';
          this.filteredFirstTableData = [];
          this.applyComparisonSummary([], 'compare');
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load Compare table data';
        console.error('❌ Compare table fetch error:', error);
      }
    );
  }

  /**
   * Fetch data for With table
   */
  fetchWithTableData(): void {
    const procurementVersionId = this.withStageType === 'Costing' ? 0 : Number(this.withVersionId);
    const versionId = this.withStageType === 'Costing' ? Number(this.withVersionId) : null;
    const projectId = Number(this.customerInfoData?.project_id || this.project_id);

    this.isLoading = true;
    const params: any = {
      project_id: projectId,
      procurement_version_id: procurementVersionId
    };

    // Include version_id only for Costing stage
    if (versionId !== null && versionId !== undefined) {
      params.version_id = versionId;
    }

    console.log('🔄 Fetching With table data with params:', params);

    this.masterService.get_Projectview(params).subscribe(
      (data: any) => {
        this.isLoading = false;

        if (data && data.results && data.results.length > 0) {
          const targetProjectName = String(this.customerInfoData?.projectName || this.projectName || '').trim().toLowerCase();
          const matchedProject = this.getMatchedVersionProject(
            data.results,
            this.withStageType,
            Number(this.withVersionId),
            targetProjectName
          );

          if (matchedProject) {
            const projectClone = JSON.parse(JSON.stringify(matchedProject));
            const currencyConversionRates: { [key: string]: number } = {
              INR: 1,
              USD: 86,
              EUR: 90
            };

            const isSourcedPart = (part: any): boolean => {
              const supplier = String(part?.supplier ?? '').trim().toLowerCase();
              return (
                !!supplier &&
                supplier !== 'n/a' &&
                supplier !== 'na' &&
                supplier !== '-' &&
                supplier !== 'null' &&
                supplier !== 'undefined' &&
                supplier !== 'none'
              );
            };

            projectClone.parts = (projectClone.parts || []).map((row: any) => {
              const landingCostInINR = Number(row.landing_cost) || 0;
              const conversionRate = currencyConversionRates[row.Currency] || 1;
              const estLandingCost = (Number(row.Price) || 0) * conversionRate * 1.28;
              const priceColor = estLandingCost > landingCostInINR ? 'green' : 'red';
              const qty = Math.max(Number(row.projectQty) || 0, Number(row.Closest_Quantity) || 0);
              const totalValueINR = isSourcedPart(row) ? (landingCostInINR * qty) : 0;

              return { ...row, priceColor, total_value_inr: totalValueINR };
            });

            this.filteredSecondTableData = [projectClone];
            this.applyComparisonSummary(this.filteredSecondTableData, 'with');
            console.log('✅ With table data updated for version:', this.withVersionId);
          } else {
            this.filteredSecondTableData = [];
            this.applyComparisonSummary([], 'with');
          }
        } else {
          this.errorMessage = 'No data available for With';
          this.filteredSecondTableData = [];
          this.applyComparisonSummary([], 'with');
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorMessage = 'Failed to load With table data';
        console.error('❌ With table fetch error:', error);
      }
    );
  }

  /**
   * Handle Compare stage type change - fetches dropdown versions then table data
   */
  onCompareStageChange(): void {
    console.log('🔄 Compare stage changed:', { compareStageType: this.compareStageType, compareVersionId: this.compareVersionId });
    this.fetchComparisonDropdown('compare', this.compareStageType);
  }

  /**
   * Handle Compare version change - fetches table data only
   */
  onCompareVersionChange(): void {
    console.log('🔄 Compare version changed:', { compareVersionId: this.compareVersionId });
    this.fetchCompareTableData();
  }

  /**
   * Handle With stage type change - fetches dropdown versions then table data
   */
  onWithStageChange(): void {
    console.log('🔄 With stage changed:', { withStageType: this.withStageType, withVersionId: this.withVersionId });
    this.fetchComparisonDropdown('with', this.withStageType);
  }

  /**
   * Handle With version change - fetches table data only
   */
  onWithVersionChange(): void {
    console.log('🔄 With version changed:', { withVersionId: this.withVersionId });
    this.fetchWithTableData();
  }

  scrollToHighlightedRow() {
    console.log('🔍 scrollToHighlightedRow called');
    console.log('  - shouldScrollToHighlight:', this.shouldScrollToHighlight);
    console.log('  - highlightedIPN:', this.highlightedIPN);
    console.log('  - selectedTabIndex:', this.selectedTabIndex);

    if (!this.shouldScrollToHighlight || !this.highlightedIPN) {
      console.log('❌ Cannot scroll: shouldScrollToHighlight =', this.shouldScrollToHighlight, 'highlightedIPN =', this.highlightedIPN);
      return;
    }

    // Try multiple selectors to find the highlighted row
    const selectors = [
      '.highlight-row',
      `tr[data-part="${this.highlightedIPN}"]`,
      `tr:has(td:contains("${this.highlightedIPN}"))`
    ];

    let element = document.querySelector('.highlight-row');

    if (element) {
      console.log('✓ Found highlighted row element');
      console.log('  - Element classes:', element.className);
      console.log('  - Element background:', window.getComputedStyle(element).backgroundColor);
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.log('❌ Highlighted row element NOT found for part:', this.highlightedIPN);

      // Debug: Check if ANY highlight-row exists in the DOM
      const allHighlightedRows = document.querySelectorAll('.highlight-row');
      console.log('  - Total .highlight-row elements in DOM:', allHighlightedRows.length);

      // Debug: Check if SUPPLY SENSE tab is visible
      const supplySenseTab = document.querySelector('mat-tab-group');
      if (supplySenseTab) {
        console.log('  - mat-tab-group found');
        console.log('  - Number of table rows:', document.querySelectorAll('table tr').length);
        console.log('  - Number of tbody rows:', document.querySelectorAll('table tbody tr').length);
      }

      // Debug: Log all rows currently visible with their part numbers
      const allRows = document.querySelectorAll('table tbody tr');
      console.log('  - Checking all visible rows for part match:');
      allRows.forEach((row, idx) => {
        const firstCell = row.querySelector('td');
        if (firstCell) {
          console.log(`    Row ${idx}: ${firstCell.textContent?.trim()}`);
        }
      });
    }
  }

  calculateFirstTableSummary() {
    this.applyComparisonSummary(this.filteredFirstTableData, 'compare');

  }
  addTotalValueToFirstTable() {

    this.filteredFirstTableData = this.filteredFirstTableData.map(project => ({
      ...project,
      parts: project.parts.map((item: any) => {

        const qty = Math.max(item.projectQty || 0, item.Closest_Quantity || 0);
        const landingCost = item.landing_cost || 0;

        return {
          ...item,
          total_value_inr: landingCost * qty
        };
      })
    }));
  }
  addTotalValueToSecondTable() {

    this.filteredSecondTableData = this.filteredSecondTableData.map(project => ({
      ...project,
      parts: project.parts.map((item: any) => {

        const qty = Math.max(item.projectQty || 0, item.Closest_Quantity || 0);
        const landingCost = item.landing_cost || 0;

        return {
          ...item,
          total_value_inr: landingCost * qty
        };
      })
    }));
  }


  calculateSecondTableSummary() {
    this.applyComparisonSummary(this.filteredSecondTableData, 'with');

  }


  onFirstDropdownChange() {
    console.log('selectedFirstSubOption => ', this.selectedFirstSubOption)
    const subOptions = this.selectedFirstOption === 'Costing' ? this.generateSubOptions('Costing') : this.generateSubOptions('Procurement');
    this.firstSubOptions = subOptions;
    this.updateFirstTable();
  }


  onSecondDropdownChange() {
    const subOptions = this.selectedSecondOption === 'Costing' ? this.generateSubOptions('Costing') : this.generateSubOptions('Procurement');
    this.secondSubOptions = subOptions;
    this.updateSecondTable(); // Refresh the table data after selection
  }


  compareandMultiply(ConvertedPrice: any, Closest_Quantity: any, projectQty: any) { return (ConvertedPrice * Math.max(Closest_Quantity, projectQty)) }

  private calculateTotalValueINR(item: any): number {
    const qty = Math.max(
      Number(item.projectQty) || 0,
      Number(item.Closest_Quantity) || 0
    );
    const landingCostInINR = Number(item.landing_cost) || 0;
    return landingCostInINR * qty;
  }

  processParts(parts: any[]): any[] {
    const currencyConversionRates: { [key: string]: number } = {
      INR: 1,
      USD: 86,
      EUR: 90
    };

    return parts.map(item => {
      const qty = Math.max(
        Number(item.projectQty) || 0,
        Number(item.Closest_Quantity) || 0
      );

      const landingCostInINR = Number(item.landing_cost) || 0;
      const totalCostINR = this.calculateTotalValueINR(item);
      const conversionRate = currencyConversionRates[item.Currency] || 1;
      const estLandingCost = (Number(item.Price) || 0) * conversionRate * 1.28;
      const priceColor = estLandingCost > landingCostInINR ? 'green' : 'red';
      return {
        ...item,
        projectQty: Number(item.projectQty) || 0,
        Inventorylevel: Number(item.Inventorylevel) || 0,
        leadTime: Number(item.leadTime) || 0,
        total_value_inr: totalCostINR,
        priceColor
      };

    });
  }

  onSubDropdownChange(type: 'first' | 'second') {
    if (type === 'first') {
      if (this.selectedFirstSubOption && this.selectedFirstSubOption !== null) {
        console.log("this.projectViewData => ", this.projectViewData)

        // this.filteredFirstTableData = this.projectViewData.filter((item:any) => {
        //   return item.version_id === Number(this.selectedFirstSubOption)
        // });
        this.filteredFirstTableData = this.projectViewData
          .filter((item: any) => item.version_id === Number(this.selectedFirstSubOption))
          .map((project: any) => ({
            ...project,
            parts: this.processParts(project.parts || [])
          }));
        let total = 0;

        this.filteredFirstTableData.forEach(project => {
          if (project.parts?.length) {
            project.parts.forEach((p: any) => {

              const qty = Math.max(
                Number(p.projectQty) || 0,
                Number(p.Closest_Quantity) || 0
              );

              const landingCost = Number(p.landing_cost) || 0;

              total += qty * landingCost;

              console.log(
                'Row Calc => qty:', qty,
                'landingCost:', landingCost,
                'rowTotal:', qty * landingCost,
                'runningTotal:', total
              );
            });
          }
        });

        this.totalSuminCompare = total;
        this.calculateFirstTableSummary();
      }
      console.log(`First dropdown selected: ${this.selectedFirstSubOption}`, "filteredFirstTableData => ", this.filteredFirstTableData);

    } else if (type === 'second') {
      if (this.selectedSecondSubOption && this.selectedSecondSubOption !== null) {
        // this.filteredSecondTableData = this.projectViewData.filter((item:any) => item.version_id === Number(this.selectedSecondSubOption));
        this.filteredSecondTableData = this.projectViewData
          .filter((item: any) => item.version_id === Number(this.selectedSecondSubOption))
          .map((project: any) => ({
            ...project,
            parts: this.processParts(project.parts || [])
          }));
        let total = 0;

        this.filteredSecondTableData.forEach(project => {
          if (project.parts?.length) {
            project.parts.forEach((p: any) => {

              const qty = Math.max(
                Number(p.projectQty) || 0,
                Number(p.Closest_Quantity) || 0
              );

              const landingCost = Number(p.landing_cost) || 0;

              total += qty * landingCost;
            });
          }
        });

        this.totalSuminwith = total;

        this.calculateSecondTableSummary();
      }
      console.log(`Second dropdown selected: ${this.selectedSecondSubOption}`);

    }

  }

  generateSubOptions(base: string): string[] {
    console.log('this.customerInfoData', this.customerInfoData)
    return this.customerInfoData.version_ids


  }


  updateFirstTable() {

    if (this.selectedFirstSubOption) {
      this.filteredFirstTableData = this.projectViewData.filter((itemList: any) =>
        itemList.parts.some((row: any) => {
          console.log("row => ", row, " row.category => ", row.category, " row.version => ", row.version)
          return row.category === this.selectedFirstOption && row.version === this.selectedFirstSubOption
        })
      );
    } else {

      this.filteredFirstTableData = this.projectViewData;
    }

    console.log('Filtered First Table Data:', this.filteredFirstTableData);
  }


  updateSecondTable() {

    if (this.selectedSecondOption && this.selectedSecondSubOption) {
      this.filteredSecondTableData = this.projectViewData.filter((itemList: any) =>
        itemList.parts.some((row: any) =>
          row.category === this.selectedSecondOption && row.version === this.selectedSecondSubOption
        )
      );
    } else {

      this.filteredSecondTableData = this.projectViewData;
    }

    console.log('Filtered Second Table Data:', this.filteredSecondTableData);
  }


  // Handle the dropdown change and update the relevant table
  updateComparisonTable(type: 'first' | 'second') {
    if (type === 'first') {
      this.updateFirstTable(); // Update first table after selection
    } else if (type === 'second') {
      this.updateSecondTable(); // Update second table after selection
    }
  }

  home() {

    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'])
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'])
    }
  }
  back() {
    if (this.showEditIcons) {
      console.log("🔙 Exiting edit mode back to normal view");
      this.cancelEditMode();
      return;
    }

    let state: any = history.state

    if (state) {
      console.log("state => ", state)
    }

    // Check if we came from analysis-manager
    if (this.fromAnalysisManager) {
      console.log("🔙 Navigating back to Analysis Manager");
      this.router.navigate(['/dashboard-manager/analysis']);
      return;
    }

    if (this.cameFromSourceBoardLink && this.selectedTabIndex === 1) {
      console.log("🔙 Returning from Supply Sense to Source Board tab");
      this.selectedTabIndex = 0;
      this.cameFromSourceBoardLink = false;

      if (this.tabGroup) {
        this.tabGroup.selectedIndex = 0;
      }

      this.cdr.detectChanges();
      return;
    }

    // Check if we came from source-pulse
    if (state?.fromSourcePulse) {
      console.log("🔙 Navigating back to Source Pulse");
      this.router.navigate(['/dashboard-engineer/source-pulse'], {
        state: {
          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,
        }
      });
      return;
    }

    if (this.userRole === 'Engineer') {
      this.router.navigate(['/dashboard-engineer'],
        {
          state: {
            startIndex: state?.startIndex ?? 0,
            endIndex: state?.endIndex ?? 10,
            rowsPerPage: state ? state.rowsPerPage : 10,
            currentPage: !!state ? state?.currentPage : 1,
            activeTab: state?.activeTab,
            selectedProjectId: state?.selectedProjectId,
          }
        })
    }
    else if (this.userRole === 'Manager' || this.userRole === 'Admin') {
      this.router.navigate(['/dashboard-manager'], {
        state: {
          startIndex: state?.startIndex ?? 0,
          endIndex: state?.endIndex ?? 10,
          rowsPerPage: state ? state.rowsPerPage : 10,
          currentPage: !!state ? state?.currentPage : 1,
          activeTab: state?.activeTab,
          selectedProjectId: state?.selectedProjectId,
        }
      })
    }

  }



  // popup for submit button

  getTransformedExportData(): any[] {
    return (this.finalConvertedData || []).map((item: any, index: number) => {
      const projectQty = Number(item.projectQty) || 0;
      const price = Number(item.Price) || 0;
      const closestQty = Number(item.Closest_Quantity) || 0;

      const totalValue = Number(item.total_value_inr) || 0;
      const unitSellingPrice = this.calculateUnitSellingPrice(item);
      const profitMarginPercent = Number(this.percentMap[this.getRowKey(item)] || 0);

      // MOQ Cost: (MOQ - projectQty) * unitSellingPrice (WITH margin applied)
      let moqValue = (closestQty - projectQty) * unitSellingPrice;

      if (moqValue < 0) {
        moqValue = 0;
      }

      return {
        'Sl no': index + 1,
        'Internal part no.': item.internalPartNo,
        'MPN': item.MPN,
        'MPN(Match)': item.specification,
        'Manufacturer': item.manufacturer,
        'Project qty': projectQty,
        'Supplier': item.supplier,
        'Country': item.country,
        'Stock': item.Inventorylevel,
        'Price': price,
        'Currency': item.Currency,
        'MOQ': closestQty,
        'leadTime': item.leadTime,
        'Total Value': totalValue,
        'MOQ Value': moqValue,
        ...(this.showPercentColumns ? {
          ...(!this.isNgpInstance ? { '% Profit Margin': profitMarginPercent } : {}),
          'Unit Selling Price': unitSellingPrice,
          'Total Selling Value': this.calculatePercentValue(item)
        } : {})
      };
    });
  }

  openExportModal(content: any): void {
    if (!this.finalConvertedData || this.finalConvertedData.length === 0) {
      this.notify.warning('No data available to export.');
      return;
    }
    this.modalRef = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: 'export-format-modal'
    });
  }

  getReviewerName(): string {
    try {
      const currentUser = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      const fullName = (currentUser?.first_name ? `${currentUser.first_name} ${currentUser.last_name || ''}`.trim() : '') ||
        currentUser?.name ||
        currentUser?.username ||
        sessionStorage.getItem('username') ||
        '';
      return (fullName || 'KAVYA').toUpperCase();
    } catch (e) {
      return (sessionStorage.getItem('username') || 'KAVYA').toUpperCase();
    }
  }

  getNgpExportRows(): any[] {
    return (this.finalConvertedData || []).map((item: any, index: number) => {
      const qty = Number(item.projectQty) || 0;
      const unitSellingPrice = this.calculateUnitSellingPrice(item);

      // MOQ / SPQ
      let moqSpq = '';
      if (item.MOQ && item.Closest_Quantity && item.MOQ !== item.Closest_Quantity) {
        moqSpq = `${item.MOQ}/${item.Closest_Quantity}`;
      } else {
        moqSpq = item.Closest_Quantity || item.MOQ || '';
      }

      return {
        slNo: index + 1,
        partNumber: item.customerPartNumber || item.internalPartNo || item['Internal Part No.'] || item.partNumber || '',
        quotedPart: item.MPN || item.specification || item['MPN(Match)'] || '',
        alternateQuoted: (item.specification && item.specification !== item.MPN) ? item.specification : '',
        description: item.description || item.Description || item.commodity || '',
        uom: item.uom || item.UOM || 'EA',
        quantity: qty,
        moqSpq: moqSpq,
        availability: item.Inventorylevel !== undefined && item.Inventorylevel !== null ? item.Inventorylevel : (item.Stock ?? item.availability ?? ''),
        unitPrice: unitSellingPrice,
        totalPrice: qty * unitSellingPrice,
        leadTime: this.getLeadTimeToShow(item),
        make: item.manufacturer || item.Make || '',
        hsnCode: item.hsnCode || item.hsn || item.HSN || '',
        coo: item.country || item.Country || item.coo || '',
        remarks: item.remarks || item.Remarks || ''
      };
    });
  }

  downloadExport(format: string): void {
    const projectName = `${this.projectName}-${this.version_id}`;

    if (format === 'xlsx') {
      if (this.isNgpInstance) {
        const ngpRows = this.getNgpExportRows();
        const reviewerName = this.getReviewerName();
        this.exportService.exportToNgpQuotationForm(
          ngpRows,
          `${projectName}_Supply_Sense_data.xlsx`,
          { reviewerName }
        );
        this.notify.success('Excel file exported successfully');
      } else {
        const transformedData = this.getTransformedExportData();
        this.exportService.exportToExcel(
          transformedData,
          `${projectName}_Supply_Sense_data.xlsx`,
          'finalConvertedData'
        );
        this.notify.success('Excel file exported successfully');
      }
    } else if (format === 'csv') {
      const transformedData = this.getTransformedExportData();
      this.exportService.exportToCSV(
        transformedData,
        `${projectName}_Supply_Sense_data.csv`
      );
      this.notify.success('CSV file exported successfully');
    } else if (format === 'docx' || format === 'word') {
      if (this.isNgpInstance) {
        const ngpRows = this.getNgpExportRows();
        const reviewerName = this.getReviewerName();
        const customerName = this.customerInfoData?.customerName || this.customerInfoData?.customer_name || '';
        const buyerName = this.customerInfoData?.buyer_name || this.customerInfoData?.buyer || this.customerInfoData?.contact_person || '';
        const buyerEmail = this.customerInfoData?.email || this.customerInfoData?.buyer_email || '';
        const buyerPhone = this.customerInfoData?.phone || this.customerInfoData?.buyer_phone || '';
        this.exportService.exportToNgpQuotationDocx(
          ngpRows,
          `${projectName}_Quotation.docx`,
          {
            reviewerName,
            projectName: `${this.projectName} (Version ${this.version_id})`,
            customerName,
            buyerName,
            buyerEmail,
            buyerPhone
          }
        );
        this.notify.success('Word quotation exported successfully');
      } else {
        const transformedData = this.getTransformedExportData();
        this.exportService.exportToDocx(
          transformedData,
          `${projectName}_Supply_Sense_data.docx`,
          `${this.projectName} (Version ${this.version_id}) - Supply Sense Report`
        );
        this.notify.success('Word document exported successfully');
      }
    } else if (format === 'pdf') {
      if (this.isNgpInstance) {
        const ngpRows = this.getNgpExportRows();
        const reviewerName = this.getReviewerName();
        this.exportService.exportToNgpQuotationPdf(
          ngpRows,
          `${projectName}_Supply_Sense_data.pdf`,
          {
            reviewerName,
            projectName: `${this.projectName} (Version ${this.version_id})`
          }
        );
        this.notify.success('PDF file exported successfully');
      } else {
        const transformedData = this.getTransformedExportData();
        this.exportService.exportToPDF(
          transformedData,
          `${projectName}_Supply_Sense_data.pdf`,
          `${this.projectName} (Version ${this.version_id}) - Supply Sense Report`
        );
        this.notify.success('PDF file exported successfully');
      }
    }

    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }

  exportData(): void {
    this.downloadExport('xlsx');
  }

  // Download sample templates
  sourcingData(): void {
    const sourcingDummyData = [
      {
        "Customer Part No.": "461500500155",
        "Internal Part No.": "461500500155",
        "Description": "CON CIRS THD PL ST M3/22A SLD",
        "Specification": "MS3106F10SL-3P/TB3106FW-10SL-3PNC",
        "Commodity": "Connectors",
        "Manufacturer(Mfg)": "AMPHENOL AEROSPACE",
        "UOM": "EA",
        "Project qty": 12.0,
        "I Sourcing": "Yes"
      }
    ];
    this.exportService.exportToExcel(sourcingDummyData, 'Source_data.xlsx', 'Source_data');
  }

  alternateData(): void {
    const avdDummyData = [
      {
        "Internal Part No.": "461517560515",
        "Manufacturer(Mfg)": "ODU GMBH & CO. KG",
        "Specification": "G80YAR-P04WFG0-000L"
      }
    ];
    this.exportService.exportToExcel(avdDummyData, 'Avd_data.xlsx', 'Avd_DataSheet');
  }

  resetFinalData() {
    this.isUploadEnabled = false;
    this.sourcingListFileName = '';
    if (this.form) {
      this.form.get('sourcingListFileName')?.setValue('');
      this.form.get('alternatePartFileName')?.setValue('');
    }
    this.alternatePartFileName = '';
    this.sourceListData = [];
    this.avdData = [];
    this.finalDataList = [];
    this.finalCompareDataList = [];
    this.headerErrorMessage = '';
    this.isHeaderMappingRequired = false;
    this.isCriteriaSelected = false;
    this.criteria = {
      stockAvailability: false,
      leadTime: false,
      minimumPrice: false,
      authorisedSuppliers: false,
      selectedSuppliers: []
    };
  }


  openPopup(offerPriceModal: any) {
    if (this.projectStatus === 'Closed') {
      // show info that project is already closed
      this.notify.info('Project is already closed.');
      return; // stop here, don’t open modal
    }

    // only runs if status is "Open"
    this.modalRef = this.modalService.open(offerPriceModal, {
      centered: true,
      backdrop: 'static',
      windowClass: 'submit-project-modal'
    });
  }



  getLeadTimeToShow(row: any): number {

    if (row.projectQty > row.Inventorylevel) {
      return row.factoryLeadDays && row.factoryLeadDays > 0
        ? row.factoryLeadDays
        : (row.estimatedFactoryLeadDays && row.estimatedFactoryLeadDays > 0
          ? row.estimatedFactoryLeadDays
          : (row.leadTime || 0));
    }


    if (row.projectQty < row.Inventorylevel) {
      return row.factoryLeadDays && row.factoryLeadDays > 0
        ? row.factoryLeadDays
        : (row.estimatedFactoryLeadDays && row.estimatedFactoryLeadDays > 0
          ? row.estimatedFactoryLeadDays
          : (row.leadTime || 0));
    }


    if (row.projectQty === row.Inventorylevel) {
      return row.factoryLeadDays && row.factoryLeadDays > 0
        ? row.factoryLeadDays
        : (row.estimatedFactoryLeadDays && row.estimatedFactoryLeadDays > 0
          ? row.estimatedFactoryLeadDays
          : (row.leadTime || 0));
    }

    // Just in case
    return row.leadTime || 0;
  }


  saveProjectViewData() {
    let obj = {
      action: "CLOSE_PROJECT",
      project_id: this.project_id,
      version_id: this.version_id
    };

    this.masterService.manage_projects(obj).subscribe((res: any) => {
      console.log('res ', res);

      if (res?.status === 'success') {

        this.projectStatus = 'Closed';

        // Optional: update local data list if needed
        const closedProject = this.finalConvertedData.find((project: any) =>
          project.project_id === this.project_id
        );
        if (closedProject) {
          closedProject.status = 'Closed';
          closedProject.closed_date = new Date().toISOString();
        }


        this.notify.success('Project closed successfully');


        if (this.modalRef) {
          this.modalRef.close();
        }
        this.modalService.dismissAll();
      } else {
        this.notify.danger(res?.message || 'Failed to close project');
      }
    }, (err) => {
      this.notify.danger('Something went wrong while closing the project.');
    });
  }


  closePopup() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.modalService.dismissAll();
  }

  getRiskColor(projectQty: number, inventoryLevel: number): string {
    if (inventoryLevel < projectQty) {
      return 'red'; // Stock available is less than required quantity
    } else if (inventoryLevel <= 3 * projectQty) {
      return 'yellow'; // Stock available is equal to or less than 3 times the required quantity
    } else {
      return 'green'; // Stock available is greater than 3 times the required quantity
    }
  }


  getLeadTimeColor(projectQty: number, inventoryLevel: number, leadTime: number) {
    //  Green: Required qty <= Inventory
    if (projectQty <= inventoryLevel) {
      return 'green';
    }

    //  Yellow: Required qty > Inventory && LT < 8 weeks
    if (projectQty > inventoryLevel && leadTime < 8) {
      return 'yellow';
    }

    //  Red: Required qty > Inventory && LT >= 8 weeks
    if (projectQty > inventoryLevel && leadTime >= 8) {
      return 'red';
    }

  }


  getPriceColor(Price: number, inventoryLevel: number): string {
    if (inventoryLevel > 0 || Price <= 6) {
      return 'green'; // Stock available OR lead time is 6 weeks or less
    } else if (Price > 6 && Price <= 10) {
      return 'yellow'; // Lead time is between 6 and 10 weeks
    } else {
      return 'red'; // Lead time is greater than 10 weeks
    }
  }
  calculateRisk(row: any): number {
    // Use priceRisk directly from the API
    const priceRisk = Number(row.priceRisk) || 0;

    return parseFloat(priceRisk.toFixed(2));
  }

  calculateMOQCost(row: any): number {
    if (!row) return 0;

    const moq = Number(row?.MOQ) || 0;
    const spq = Number(row?.Closest_Quantity) || 0;
    const projectQty = Number(row?.projectQty) || 0;
    const convertedPrice = Number(row?.ConvertedPrice) || 0;

    // Determine which is higher: MOQ or SPQ
    const higherValue = Math.max(moq, spq);

    // If higher value > project qty, calculate excess cost
    if (higherValue > projectQty) {
      const excessQty = higherValue - projectQty;
      return excessQty * convertedPrice;
    }

    return 0;
  }

  sendRFQ() {
    this.showRFQCheckboxes = true;

    // Auto-select rows where supplier is N/A
    console.log('finalConvertedData => ', this.finalConvertedData, 'rfqSelected => ', this.rfqSelected)
    this.finalConvertedData.forEach((row: any, rowI: number) => {
      this.rfqSelected[row.internalPartNo] = (row.supplier === 'N/A');
    });

    this.showFetch = true;
  }

  preparePayload() {
    // Filter only selected rows
    this.selectedPartsPayload = this.finalConvertedData
      .filter((row: any) => this.rfqSelected[row.internalPartNo]) // only checked
      .map((row: any) => ({
        internalPartNo: row.internalPartNo,
        customerPartNumber: row.customerPartNumber,
        description: row.description,
        mpn: row.MPN,
        mpnMatch: row.MPN,
        make: row.manufacturer,
        commodity: row.commodity,
        uom: row.uom,
        quantity: row.projectQty
      }));

    console.log("Payload ready:", this.selectedPartsPayload);
  }

  fetchsuppliers() {
    this.preparePayload();

    // Store payload in sessionStorage so merge component can access
    sessionStorage.setItem("rfqPayload", JSON.stringify(this.selectedPartsPayload));


    this.sendDataToComponents('/merge-data', { rfqSelected: this.rfqSelected })
  }
  cancelRFQ() {
    this.showRFQCheckboxes = false;
    this.showFetch = false;
    this.rfqSelected = {};
  }

  sendDetapics(): void {
    const payload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: this.customerInfoData?.procurement_version_id ?? 0,
    };

    console.log('sendDetapics: calling get_project_part_details_Top_N_Seller with payload =>', payload);

    this.masterService.get_project_part_details_Top_N_Seller(payload).subscribe({
      next: (res: any) => {
        const results = res?.results;
        if (!results || results.length === 0) {
          this.notify.warning('No supplier data available to send.');
          return;
        }

        const customerName = results[0]?.project?.customerName
          || results[0]?.project?.customer_name
          || results[0]?.customerName
          || results[0]?.customer_name
          || this.customerInfoData?.customerName
          || this.customerInfoData?.customer_name
          || '';

        const rfqSourcingItemsUpdateDtos: any[] = [];

        results.forEach((result: any) => {
          const projectParts: any[] = result.project_parts || [];

          projectParts.forEach((pp: any) => {
            const partHeader = pp.part_header || {};
            const ipn = partHeader.internalPartNo || 'UNKNOWN';
            const projectQty = partHeader.projectQty || 0;

            const allOffers: any[] = [];
            const partDetails: any[] = pp.part_details || [];

            partDetails.forEach((detail: any) => {
              const topN = detail.Top_N_Sellers || {};
              (topN.nexar || []).forEach((o: any) => allOffers.push(o));
              (topN.offline || []).forEach((o: any) => allOffers.push(o));
              (topN.vendor || []).forEach((o: any) => allOffers.push(o));
            });

            const matchedPart = this.finalConvertedData.find((item: any) => item.internalPartNo === ipn);
            const sellerId = matchedPart ? (matchedPart.Seller_ID || matchedPart.Seller_Id || 0) : 0;
            const itemSpq = matchedPart?.Closest_Quantity ?? matchedPart?.SPQ ?? matchedPart?.spq ?? (allOffers.length > 0 ? (allOffers[0].Closest_Quantity || allOffers[0].SPQ) : 0) ?? 0;
            const itemStock = matchedPart?.Inventorylevel ?? matchedPart?.Stock ?? matchedPart?.AvailableStock ?? (allOffers.length > 0 ? (allOffers[0].Inventorylevel || allOffers[0].Stock) : 0) ?? 0;
            const itemUom = partHeader.uom || partHeader.UOM || matchedPart?.uom || matchedPart?.UOM || '';

            rfqSourcingItemsUpdateDtos.push({
              // id: Number(sellerId) || 0,
              id: 0,
              itemNumber: ipn,
              itemDescription: partHeader.description || '',
              qtyReq: projectQty,
              uom: itemUom,
              count: allOffers.length,
              isItemSourcing: allOffers.length > 0,
              SPQ: String(itemSpq),
              AvailableStock: String(itemStock),
              spq: String(itemSpq),
              availableStock: String(itemStock),
              rfqSourcingVendorDtos: allOffers.map((offer: any, idx: number) => {
                const vendorId = `${(offer.supplier || 'VENDOR').replace(/\s+/g, '_').toUpperCase()}_${ipn}_${idx + 1}`;
                const vendorSpq = offer.SPQ ?? offer.spq ?? offer.Closest_Quantity ?? offer.closest_quantity ?? matchedPart?.Closest_Quantity ?? matchedPart?.spq ?? matchedPart?.SPQ ?? 0;
                const vendorStock = offer.AvailableStock ?? offer.availableStock ?? offer.available_stock ?? offer.Inventorylevel ?? offer.inventoryLevel ?? offer.Stock ?? offer.stock ?? matchedPart?.Inventorylevel ?? matchedPart?.Stock ?? matchedPart?.AvailableStock ?? 0;

                return {
                  id: 0,
                  vendor: offer.supplier || '',
                  vendorId: vendorId,
                  unitPrice: Number(offer.Price) || 0,
                  unitPricePer: String(Number(offer.Price) || 0),
                  currency: offer.Currency || 'INR',
                  moq: String(offer.MOQ || offer.Closest_Quantity || 0),
                  SPQ: String(vendorSpq),
                  AvailableStock: String(vendorStock),
                  spq: String(vendorSpq),
                  availableStock: String(vendorStock),
                  leadTime: offer.estimatedFactoryLeadDays ? String(Number(offer.estimatedFactoryLeadDays) * 7) : '',
                  freight: offer.AirFreightCharge,
                  duties: offer.total_effective_duty,
                  quoteQty: Number(offer.projectQty) || projectQty,
                  landingPrice: Number(offer.LandingCost || offer.landing_cost) || 0,
                  moqCost: this.calculateMOQCost(offer),
                  quoteDate: new Date().toISOString(),
                  quoteValidity: new Date().toISOString(),
                  primary: offer.Isfinalized,
                  paymentTerms: '',
                  remarks: '',
                  fileIds: ''
                };
              })
            });
          });
        });

        const rfqPayload = {
          id: 0,
          rfqId: 0,
          rfqNumber: this.projectName || '',
          customerName: customerName,
          unit: 'Bangalore',
          rfqSourcingItemsUpdateDtos
        };

        console.log('Detapics rfqPayload =>', rfqPayload);

        this.masterService.updateSourcingRfq(rfqPayload).subscribe({
          next: (updateRes: any) => {
            this.notify.success('GetAPcs data sent successfully.');
            console.log('Detapics response =>', updateRes);
          },
          error: (err: any) => {
            this.notify.danger('Failed to send GetAPcs data. Please try again.');
            console.error('Detapics updateSourcingRfq error =>', err);
          }
        });
      },
      error: (err: any) => {
        this.notify.danger('Failed to fetch part details. Please try again.');
        console.error('Detapics get_project_part_details_Top_N_Seller error =>', err);
      }
    });
  }

  onRFQCheckboxChange(row: any, event: any) {
    this.rfqSelected[row.internalPartNo] = event.target.checked;
  }


  QSourcing() {
    console.log("✓ Navigating to Sourcing with Tab Index:", this.selectedTabIndex);
    this.router.navigate(['/sourcing'], { state: { selectedTabIndex: this.selectedTabIndex } });
  }
  // Check if all rows are selected
  isAllSelected(): boolean {
    if (!this.filteredData?.length) return false;
    return this.filteredData.every(row =>
      row.supplier !== 'N/A' && this.rfqSelected[row.internalPartNo]
    );
  }

  // Toggle all
  toggleAllSelection(event: any) {
    const checked = event.target.checked;
    this.filteredData.forEach((row: any, rowI: number) => {
      console.log(rowI, ' row => ', row)
      if (row.supplier !== 'N/A') {
        this.rfqSelected[row.internalPartNo] = checked;
      }
    });
    console.log('this.rfqSelected => ', this.rfqSelected)
  }

  onPoDataClick(row: any) {
    sessionStorage.setItem('internalPartNo', String(row?.internalPartNo));
    sessionStorage.setItem('mpnMatch', String(row?.MPN));
    sessionStorage.setItem('project_id', String(this.project_id));
    sessionStorage.setItem('version_id', String(this.version_id));
    sessionStorage.setItem('projectQty', String(row?.projectQty));
    sessionStorage.setItem('projectSupplierInfo', JSON.stringify(row));
    let customerInfo: any = structuredClone(this.customerInfoData);
    console.log('customerInfo before deleting parts:', customerInfo);
    let state: any = history.state
    this.router.navigate(['/part-info'], {
      state: {
        internalPartNo: row.internalPartNo,
        projectQty: row.projectQty,
        customerInfo: this.customerInfoData,
        fromProjectView: true,
        selectedTabIndex: this.selectedTabIndex,
        startIndex: state?.startIndex ?? 0,
        endIndex: state?.endIndex ?? 10,
        rowsPerPage: state ? state.rowsPerPage : 10,
        currentPage: !!state ? state?.currentPage : 1,
      }
    });
  }

  Data(dataPrefModal: any) {
    console.log('Data Preference clicked');
    this.modalRef = this.modalService.open(dataPrefModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' });
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === 'ESC') {
      return 'by pressing ESC';
    } else if (reason === 'BACKDROP_CLICK') {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  saveDataPreference() {
    console.log('Selected Data Preference:', this.dataPreference);
    this.modalRef!.close();
  }


  // Initialize with selected data preferences as an array
  dataPreference: string[] = ['vendor'];

  // Function to update selection on checkbox change
  onDataPrefChange(option: string, isChecked: boolean) {
    if (isChecked) {
      if (!this.dataPreference.includes(option)) {
        this.dataPreference.push(option);
      }
    } else {
      this.dataPreference = this.dataPreference.filter(item => item !== option);
    }
  }

  closeModal() {

    if (this.modalRef) {
      this.modalRef.close();
    } else {
      this.modalService.dismissAll();
    }
  }
  manufacturerMatches: string[] = [];
  showMakeDropdown = false;
  isLoadingMake = false;
  isMakeInvalid = false;
  manufacturerMatchesCache: string[] = [];
  makeSearchTimeout: any;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (this.showMakeDropdown && !target.closest('.make-dropdown-container')) {
      this.showMakeDropdown = false;
      this.isMakeInvalid = false;
    }
  }

  onMakeBlur() {
    setTimeout(() => {
      this.showMakeDropdown = false;
      this.isMakeInvalid = false;
    }, 200);
  }

  searchManufacturerAPI(value: string) {
    const searchText = value?.trim();

    if (!searchText) {
      this.manufacturerMatches = [];
      this.manufacturerMatchesCache = [];
      this.showMakeDropdown = false;
      this.isMakeInvalid = false;
      return;
    }

    clearTimeout(this.makeSearchTimeout);

    this.makeSearchTimeout = setTimeout(() => {

      const payload = { name: searchText };
      this.isLoadingMake = true;

      this.masterService.manufacturer_Name_search(payload).subscribe({
        next: (res: any) => {
          this.manufacturerMatches = res?.matches || [];
          this.manufacturerMatchesCache = [...this.manufacturerMatches];

          this.showMakeDropdown = this.manufacturerMatches.length > 0;
          this.isLoadingMake = false;
          this.isMakeInvalid = false;
        },

        error: () => {
          this.manufacturerMatches = [];
          this.manufacturerMatchesCache = [];
          this.showMakeDropdown = false;
          this.isLoadingMake = false;
          this.isMakeInvalid = false;
        }
      });

    }, 300);
  }

  selectManufacturers(make: string) {
    this.newPart.manufacturer = make;
    this.showMakeDropdown = false;
    this.isMakeInvalid = false;
  }

  // ===== TRIGGER SOURCING MODE =====

  enableTriggerMode() {
    this.cancelDeleteMode();
    if (this.showTriggerCheckboxes) {
      this.cancelTriggerMode();
    } else {
      this.showTriggerCheckboxes = true;
      this.triggerSelected = {};
      this.isCriteriaSelected = false;
    }
  }

  cancelTriggerMode() {
    this.showTriggerCheckboxes = false;
    this.triggerSelected = {};
    this.isCriteriaSelected = false;
  }

  onTriggerCheckboxChange(row: any, event: any) {
    this.triggerSelected[row.internalPartNo] = event.target.checked;
  }

  isTriggerAllSelected(): boolean {
    if (!this.filteredData?.length) return false;
    return this.filteredData.every(row => this.triggerSelected[row.internalPartNo]);
  }

  toggleTriggerAllSelection(event: any) {
    const checked = event.target.checked;
    this.filteredData.forEach((row: any) => {
      this.triggerSelected[row.internalPartNo] = checked;
    });
  }

  getTriggerSelectedCount(): number {
    return Object.keys(this.triggerSelected).filter(key => this.triggerSelected[key]).length;
  }

  // ===== MULTIPLE PART DELETE MODE =====

  showDeleteCheckboxes: boolean = false;
  deleteSelected: { [key: string]: boolean } = {};
  isDeletingParts: boolean = false;

  enableDeleteMode() {
    this.cancelTriggerMode();
    if (this.showDeleteCheckboxes) {
      this.cancelDeleteMode();
    } else {
      this.showDeleteCheckboxes = true;
      this.deleteSelected = {};
    }
  }

  cancelDeleteMode() {
    this.showDeleteCheckboxes = false;
    this.deleteSelected = {};
    this.isDeletingParts = false;
  }

  onDeleteCheckboxChange(row: any, event: any) {
    this.deleteSelected[row.internalPartNo] = event.target.checked;
  }

  isDeleteAllSelected(): boolean {
    if (!this.filteredData?.length) return false;
    return this.filteredData.every(row => this.deleteSelected[row.internalPartNo]);
  }

  toggleDeleteAllSelection(event: any) {
    const checked = event.target.checked;
    this.filteredData.forEach((row: any) => {
      this.deleteSelected[row.internalPartNo] = checked;
    });
  }

  getDeleteSelectedCount(): number {
    return Object.keys(this.deleteSelected).filter(key => this.deleteSelected[key]).length;
  }

  deleteSelectedParts() {
    if (this.isReviewStage) {
      this.notify.warning("Editing is not allowed when the project is in the review stage.");
      return;
    }

    const selectedInternalPartNos = Object.keys(this.deleteSelected).filter(
      key => this.deleteSelected[key]
    );

    if (selectedInternalPartNos.length === 0) {
      this.notify.warning('Please select at least one part to delete.');
      return;
    }

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${selectedInternalPartNos.length} selected part(s)?`
    );
    if (!confirmDelete) {
      return;
    }

    this.isDeletingParts = true;

    const engineerId = Number(this.engineer_id ?? sessionStorage.getItem('engineer_id') ?? 0);
    const managerId = Number(this.manager_id ?? sessionStorage.getItem('manager_id') ?? 0);
    const procVersionId = this.fromProcurement
      ? Number(this.procurement_version_id || 0)
      : Number(this.customerInfoData?.procurement_version_id ?? 0);

    const deleteRequests = selectedInternalPartNos.map(ipn => {
      const payload = {
        project_id: Number(this.project_id),
        version_id: Number(this.version_id),
        procurement_version_id: procVersionId,
        internalPartNo: String(ipn),
        engineer_id: engineerId,
        manager_id: managerId,
        collection_id: "1"
      };
      return this.masterService.Delete_part(payload);
    });

    forkJoin(deleteRequests).subscribe({
      next: () => {
        this.isDeletingParts = false;
        this.notify.success('Selected parts deleted successfully');

        const deletedSet = new Set(selectedInternalPartNos);
        this.filteredData = this.filteredData.filter((item: any) => !deletedSet.has(item.internalPartNo));
        this.finalConvertedData = this.finalConvertedData.filter((item: any) => !deletedSet.has(item.internalPartNo));

        this.cancelDeleteMode();
      },
      error: (err) => {
        console.error('Delete parts error:', err);
        this.isDeletingParts = false;
        this.notify.danger('Failed to delete some or all selected parts');
        this.getdata();
      }
    });
  }

  triggerSourcingForSelected() {
    const selectedRows = this.filteredData.filter(
      (row: any) => this.triggerSelected[row.internalPartNo]
    );

    if (selectedRows.length === 0) {
      this.notify.warning('Please select at least one part to trigger sourcing.');
      return;
    }

    const rawSuppliers = this.criteria.selectedSuppliers || [];
    const normalizedSuppliers: string[] = (Array.isArray(rawSuppliers) ? rawSuppliers : [rawSuppliers])
      .map((s: any) => {
        if (!s) return '';
        if (typeof s === 'string') return s.trim();
        if (typeof s === 'object') return (s.name || s.supplierName || s.label || '').trim();
        return String(s).trim();
      })
      .filter((s: string) => s.length > 0);

    const hasSelectedSuppliers = normalizedSuppliers.length > 0;
    const isAuthSuppliers = Boolean(this.criteria.authorisedSuppliers || hasSelectedSuppliers);

    const procVersionId = this.fromProcurement
      ? Number(this.procurement_version_id || 0)
      : Number(this.customerInfoData?.procurement_version_id ?? sessionStorage.getItem('procurement_version_id') ?? 0);

    const sourcingType = (this.dataPreference && this.dataPreference.length > 0)
      ? this.dataPreference
      : ['vendor'];

    const payload = {
      project_id: Number(this.project_id),
      version_id: Number(this.version_id),
      procurement_version_id: procVersionId,
      sourcing_type: sourcingType,

      data: selectedRows.map((row: any) => {
        let rowSuppliers: string[] = [];
        if (hasSelectedSuppliers) {
          rowSuppliers = [...normalizedSuppliers];
        } else if (Array.isArray(row.suppliers) && row.suppliers.length > 0) {
          rowSuppliers = row.suppliers
            .map((s: any) => typeof s === 'string' ? s.trim() : (s?.name || s?.supplierName || String(s)).trim())
            .filter(Boolean);
        }

        return {
          part_header: {
            internalPartNo: row.internalPartNo,
            customerPartNumber: row.customerPartNumber || '',
            description: row.description || '',
            commodity: row.commodity || '',
            uom: row.uom || '',
            projectQty: Number(row.projectQty) || 0,
            iSourcing: row.iSourcing || 'No',
            stockAvailability: this.boolToNumber(this.criteria.stockAvailability),
            leadTime: this.boolToNumber(this.criteria.leadTime),
            minimumPrice: this.boolToNumber(this.criteria.minimumPrice),
            authorisedSuppliers: isAuthSuppliers ? 1 : 0,
            suppliers: rowSuppliers,
            eau: Number(row.eau) || 0
          },
          Parts: (row.Parts && Array.isArray(row.Parts) && row.Parts.length > 0)
            ? row.Parts.map((p: any) => ({
                specification: p.specification || p.mpn || '',
                manufacturer: p.manufacturer || ''
              }))
            : [
                {
                  specification: row.specification || row.MPN || '',
                  manufacturer: row.manufacturer || ''
                }
              ]
        };
      })
    };

    console.log('Trigger Sourcing Payload =>', payload);
    this.isTriggerSourcing = true;

    this.masterService.finalCompareData(payload).subscribe({
      next: (res: any) => {
        console.log('Trigger Sourcing API Success', res);
        this.isTriggerSourcing = false;
        this.isDataInProgress = true;
        this.notify.info('Data In-Progress, please wait...');

        setTimeout(() => {
          this.getdata();
          this.isDataInProgress = false;
          this.cancelTriggerMode();
          this.notify.success('Trigger sourcing completed successfully');
        }, 10000);
      },
      error: (err) => {
        console.error('Trigger Sourcing API Error', err);
        this.isTriggerSourcing = false;
        this.notify.danger('Trigger sourcing failed');
      }
    });
  }

  openMpnInfoPopup(row: any, content: any): void {
    this.selectedIpnForInfo = row?.internalPartNo || '';
    this.selectedMpnForInfo = row?.MPN || '';
    this.selectedMfgForInfo = row?.manufacturer || '';
    this.isLoadingIpnInfo = true;

    // Open the modal immediately
    this.modalRef = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      windowClass: 'sourcing-relationships-modal'
    });

    const projId = Number(this.project_id);
    const verId = Number(this.version_id);
    const procId = this.fromProcurement ? this.procurement_version_id : 0;

    this.masterService.getInputSourceDropdown(projId, verId, procId).subscribe({
      next: (res: any) => {
        this.isLoadingIpnInfo = false;

        // Filter relationships based on the selected internal part number
        const relations = res?.relationships || [];
        this.ipnInfoRelationships = relations.filter(
          (r: any) => r.internal_part_numbers === this.selectedIpnForInfo
        );

        // Get unique MPNs and Manufacturers counts for this IPN
        const uniqueMpns = new Set(this.ipnInfoRelationships.map((r: any) => r.specification).filter(Boolean));
        const uniqueMfgs = new Set(this.ipnInfoRelationships.map((r: any) => r.manufacturer).filter(Boolean));

        this.ipnInfoMpnCount = uniqueMpns.size;
        this.ipnInfoMfgCount = uniqueMfgs.size;
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error("Error fetching input source dropdown options:", err);
        this.isLoadingIpnInfo = false;
        this.ipnInfoRelationships = [];
        this.ipnInfoMpnCount = 0;
        this.ipnInfoMfgCount = 0;
        this.notify?.danger("Failed to load sourcing details.");
        this.cdr.detectChanges();
      }
    });
  }

  loadProjectRelationships(): void {
    const projId = Number(this.project_id);
    const verId = Number(this.version_id);
    const procId = this.fromProcurement ? this.procurement_version_id : 0;

    if (projId && verId) {
      this.masterService.getInputSourceDropdown(projId, verId, procId).subscribe({
        next: (res: any) => {
          this.projectRelationships = res?.relationships || [];
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error("Error fetching project relationships:", err);
        }
      });
    }
  }

  isMpnInRelationships(row: any): boolean {
    if (!this.projectRelationships || this.projectRelationships.length === 0) {
      return false;
    }
    const mpnValue = row?.MPN || '';
    const ipnValue = row?.internalPartNo || '';
    return this.projectRelationships.some(
      (r: any) => r.internal_part_numbers === ipnValue && r.specification === mpnValue
    );
  }

}

